(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8491],{

/***/ 41628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgPhone(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12.04,
    viewBox: "0 0 15.044 15"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.179 8.274a2.375 2.375 0 01-.506-.091 7.126 7.126 0 01-.989-.294 1.51 1.51 0 00-1.872.755l-.166.34a9.2 9.2 0 01-2.008-1.511 9.2 9.2 0 01-1.51-2.008l.317-.211A1.51 1.51 0 007.2 3.382a7.8 7.8 0 01-.294-.989 5.66 5.66 0 01-.091-.513A2.265 2.265 0 004.55 0H2.286A2.265 2.265 0 00.018 2.574 14.343 14.343 0 0012.492 15h.287a2.259 2.259 0 002.265-2.272V10.46a2.265 2.265 0 00-1.865-2.186zm.377 4.529a.755.755 0 01-.257.566.793.793 0 01-.619.189A12.833 12.833 0 011.576 2.4a.823.823 0 01.189-.619.755.755 0 01.566-.257h2.265a.755.755 0 01.755.6q.045.31.113.611a8.4 8.4 0 00.347 1.17l-1.057.491a.755.755 0 00-.37 1 10.938 10.938 0 005.284 5.284.8.8 0 001-.393l.468-1.057a10.335 10.335 0 001.193.347q.3.068.611.113a.755.755 0 01.6.755z",
    fill: "#1053ff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgPhone);

/***/ }),

/***/ 69780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgRupeeGreen(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 10,
    cy: 10.135,
    r: 8.333,
    fill: "#0EA546"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.5 6.802h5m-4.167 0a2.5 2.5 0 110 5H7.5l2.5 2.5m-2.5-5h5",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgRupeeGreen);

/***/ }),

/***/ 55525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgCopy(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.77 122.88"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M89.62 13.96v7.73h12.2v.02c3.85.01 7.34 1.57 9.86 4.1 2.5 2.51 4.06 5.98 4.07 9.82h.02v73.3h-.02c-.01 3.84-1.57 7.33-4.1 9.86-2.51 2.5-5.98 4.06-9.82 4.07v.02H40.1v-.02c-3.84-.01-7.34-1.57-9.86-4.1-2.5-2.51-4.06-5.98-4.07-9.82h-.02V92.51h-12.2v-.02c-3.84-.01-7.34-1.57-9.86-4.1-2.5-2.51-4.06-5.98-4.07-9.82H0V13.95h.02c.01-3.85 1.58-7.34 4.1-9.86C6.63 1.59 10.1.03 13.94.02V0H75.67v.02c3.85.01 7.34 1.57 9.86 4.1 2.5 2.51 4.06 5.98 4.07 9.82h.02v.02zm-10.58 7.73v-7.75h.02c0-.91-.39-1.75-1.01-2.37-.61-.61-1.46-1-2.37-1v.02H13.95v-.02c-.91 0-1.75.39-2.37 1.01-.61.61-1 1.46-1 2.37h.02v64.62h-.02c0 .91.39 1.75 1.01 2.37.61.61 1.46 1 2.37 1v-.02h12.2V35.64h.02c.01-3.85 1.58-7.34 4.1-9.86 2.51-2.5 5.98-4.06 9.82-4.07v-.02H79.04zm26.14 87.23V35.63h.02c0-.91-.39-1.75-1.01-2.37-.61-.61-1.46-1-2.37-1v.02H40.09v-.02c-.91 0-1.75.39-2.37 1.01-.61.61-1 1.46-1 2.37h.02v73.3h-.02c0 .91.39 1.75 1.01 2.37.61.61 1.46 1 2.37 1v-.02H101.83v.02c.91 0 1.75-.39 2.37-1.01.61-.61 1-1.46 1-2.37h-.02v-.01z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgCopy);

/***/ }),

/***/ 18230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLocationGrey(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.993 1.95A5.742 5.742 0 016 .334c1.503 0 2.944.582 4.007 1.618a5.453 5.453 0 011.66 3.905c0 1.465-.597 2.87-1.66 3.905l-3.658 3.566a.5.5 0 01-.698 0L1.993 9.76A5.515 5.515 0 01.765 7.97a5.401 5.401 0 010-4.227A5.515 5.515 0 011.993 1.95zM6 7.435c.43 0 .841-.166 1.145-.462.303-.296.474-.697.474-1.116 0-.418-.17-.82-.474-1.116A1.64 1.64 0 006 4.278c-.43 0-.841.167-1.145.462a1.558 1.558 0 00-.474 1.116c0 .419.17.82.474 1.116A1.64 1.64 0 006 7.434z",
    fill: "#818181"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLocationGrey);

/***/ }),

/***/ 70074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgVerifiedTick(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.582 5.91l-.317-.216a.972.972 0 01-.383-1.077l.1-.364c.167-.564-.216-1.144-.8-1.243l-.383-.066a.97.97 0 01-.816-.796l-.067-.38a.986.986 0 00-1.25-.78l-.366.117c-.4.116-.85-.033-1.083-.365L8.984.41a.986.986 0 00-1.467-.15l-.283.266a.984.984 0 01-1.15.132L5.752.475a1.004 1.004 0 00-1.4.497l-.15.365a.957.957 0 01-.965.613l-.384-.017A.972.972 0 001.82 2.977l.034.381a.995.995 0 01-.6.978l-.35.149A.987.987 0 00.42 5.876l.2.332A.97.97 0 01.503 7.35l-.25.282A.964.964 0 00.436 9.09l.317.215c.35.232.5.68.383 1.077l-.15.381c-.166.563.217 1.143.8 1.243l.383.066a.97.97 0 01.817.795l.066.381c.1.58.683.945 1.25.779l.366-.116c.4-.116.85.033 1.083.364l.234.315a.986.986 0 001.466.15l.283-.266a.984.984 0 011.15-.132l.333.182c.516.281 1.166.05 1.4-.497l.15-.365a.956.956 0 01.966-.613l.383.017a.972.972 0 001.033-1.044l-.017-.38a.995.995 0 01.6-.978l.35-.15a.987.987 0 00.483-1.391l-.2-.331a.97.97 0 01.117-1.144l.25-.281a.961.961 0 00-.15-1.459zM7.934 9.04l-1.366 1.343-1.35-1.359-1.3-1.309 1.367-1.342 1.3 1.31L9.7 4.6l1.35 1.36-3.116 3.08z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgVerifiedTick);

/***/ }),

/***/ 11831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgRatingStar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#rating-star_svg__clip0_7573_5431)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.321 2.157c.214-.654 1.145-.654 1.358 0l1.085 3.315a.71.71 0 00.678.49h3.51c.691 0 .978.879.42 1.283l-2.84 2.048a.71.71 0 00-.259.793l1.084 3.315c.214.654-.54 1.198-1.098.793l-2.84-2.048a.717.717 0 00-.839 0l-2.839 2.048c-.559.405-1.312-.14-1.098-.793l1.084-3.315a.705.705 0 00-.26-.793L1.63 7.245c-.56-.404-.271-1.284.42-1.284h3.508a.717.717 0 00.68-.49L7.32 2.158z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "rating-star_svg__clip0_7573_5431"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgRatingStar);

/***/ }),

/***/ 16298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LineDivider; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
;// CONCATENATED MODULE: ../core-ui/dist/components/LineDivider/LineDivider.styles.js



const StyledLineDivider = styled_components_browser_esm/* default.span */.ZP.span `
    display: inline-block;
    width: ${({ width }) => (width ? width : "100%")};
    margin: ${({ margin }) => (margin ? margin : "1px 0")};
    border-bottom-width: ${({ borderWidth }) => borderWidth ? `${borderWidth}px` : "1px"};
    border-bottom-color: ${({ color }) => (color ? color : colors/* default.GREY_300 */.Z.GREY_300)};
    border-bottom-style: ${({ styleType }) => styleType ? styleType : "dashed"};
`;
const StyledLinearLineDivider = styled_components_browser_esm/* default.div */.ZP.div `
    height: ${({ linearGradientHeight }) => `${linearGradientHeight ? linearGradientHeight + "px" : "2px"}`};
    background: ${({ color, linearGradientDirect }) => linearGradientDirect === "toLeft"
    ? `linear-gradient(to left, #fff, ${color ? color : colors/* default.GREY_200 */.Z.GREY_200})`
    : linearGradientDirect === "toRight"
        ? `linear-gradient(to left, ${color ? color : colors/* default.GREY_200 */.Z.GREY_200}, #fff)`
        : `linear-gradient(to left, #fff, ${color ? color : colors/* default.GREY_200 */.Z.GREY_200}, #fff)`};
    width: ${({ width }) => (width ? width : "100%")};
    margin: ${({ margin }) => (margin ? margin : "1px 0")};
`;


//# sourceMappingURL=LineDivider.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/LineDivider/LineDivider.js




const LineDivider = (0,react.forwardRef)((props, ref) => {
    return props.linearGradient ? ((0,jsx_runtime.jsx)(StyledLinearLineDivider, Object.assign({}, props))) : ((0,jsx_runtime.jsx)(StyledLineDivider, Object.assign({}, props)));
});


//# sourceMappingURL=LineDivider.js.map


/***/ }),

/***/ 25354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _LineDivider_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _LineDivider_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16298);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 60894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Radio_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Radio_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84789);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 76067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DotSeparatedList; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/methods/common.js
var common = __webpack_require__(28052);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/theme.js
var theme = __webpack_require__(63298);
// EXTERNAL MODULE: ../core-ui/dist/constants/files.js
var files = __webpack_require__(65357);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
;// CONCATENATED MODULE: ../core-ui/dist/components/common/DotSeparatedList/DotSeparatedList.styles.js









const ListContainer = styled_components_browser_esm/* default.div */.ZP.div `
    display: inline-flex;
    ${({ alignItems = "flex-start", justifyContent, flexWrap }) => {
    return (0,styled_components_browser_esm/* css */.iv)({
        alignItems,
        justifyContent,
        flexWrap,
    });
}}
`;
const ListItem = styled_components_browser_esm/* default.div */.ZP.div `
    display: inline-flex;
    &:not(:last-child)::after {
        content: "•";
        margin: 0 ${({ gap }) => (0,common/* getSizeInPx */.tf)(gap)};
        color: ${({ separatorColor }) => separatorColor ? separatorColor : colors/* default.GREY_600 */.Z.GREY_600};
    }
`;


//# sourceMappingURL=DotSeparatedList.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/common/DotSeparatedList/DotSeparatedList.js



const DotSeparatedList = ({ items, separatorColor, alignItems, gap = 8, flexWrap, justifyContent, }) => {
    return ((0,jsx_runtime.jsx)(ListContainer, Object.assign({ alignItems: alignItems, justifyContent: justifyContent, flexWrap: flexWrap }, { children: items.map(({ id, node, show = true }, index) => show && ((0,jsx_runtime.jsx)(ListItem, Object.assign({ id: id, separatorColor: separatorColor, gap: gap }, { children: node }), index))) })));
};


//# sourceMappingURL=DotSeparatedList.js.map


/***/ }),

/***/ 72720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31013);
/* harmony import */ var _vahak_core_ui_dist_components_common_BordererCard_BordererCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56832);
/* harmony import */ var _methods_uiUtil__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34695);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71960);
/* harmony import */ var _vahak_core_ui_dist_components_common_DotSeparatedList_DotSeparatedList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76067);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94897);
/* harmony import */ var _vahak_core_ui_dist_methods_time__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72);
/* harmony import */ var _posting_form_common_posting_chip_PostingChip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6330);
/* harmony import */ var _vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26513);
/* harmony import */ var _vahak_core_ui_dist_methods__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38920);














var DispositionCard = function(param) {
    var data = param.data, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var ref;
    var isMobileScreen = (0,_vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        queryType: "mobile"
    });
    var ref1;
    var list = [
        (0,_methods_uiUtil__WEBPACK_IMPORTED_MODULE_11__/* .generateSelectOption */ .Ow)("Status", "Status: ".concat(data === null || data === void 0 ? void 0 : data.status), data === null || data === void 0 ? void 0 : data.status),
        (0,_methods_uiUtil__WEBPACK_IMPORTED_MODULE_11__/* .generateSelectOption */ .Ow)("Disposition", "Disposition: ".concat(data === null || data === void 0 ? void 0 : data.disposition), data === null || data === void 0 ? void 0 : data.disposition),
        (0,_methods_uiUtil__WEBPACK_IMPORTED_MODULE_11__/* .generateSelectOption */ .Ow)("Sub-Disposition", "Sub-Disposition: ".concat(data === null || data === void 0 ? void 0 : data.sub_disposition), data === null || data === void 0 ? void 0 : data.sub_disposition),
        (0,_methods_uiUtil__WEBPACK_IMPORTED_MODULE_11__/* .generateSelectOption */ .Ow)("Closing", "Closing: ".concat(data === null || data === void 0 ? void 0 : data.closing), data === null || data === void 0 ? void 0 : data.closing)
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(Object.entries((ref1 = data === null || data === void 0 ? void 0 : (ref = data.dispositions_data) === null || ref === void 0 ? void 0 : ref.disposition_information) !== null && ref1 !== void 0 ? ref1 : {}).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        var label = (0,_vahak_core_ui_dist_methods__WEBPACK_IMPORTED_MODULE_10__/* .stringOperations */ .$M)(key, [
            "capitalizeEachWord",
            "replaceUnderscoreWithSpace"
        ]);
        return (0,_methods_uiUtil__WEBPACK_IMPORTED_MODULE_11__/* .generateSelectOption */ .Ow)(label, "".concat(label, ": ").concat(value), value);
    })));
    var ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_common_BordererCard_BordererCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        width: isMobileScreen || fullWidth ? "100%" : 1000,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            flexDirection: "column",
            gap: 16,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    weight: "medium",
                    color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].GREY_600 */ .Z.GREY_600,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_common_DotSeparatedList_DotSeparatedList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        items: [
                            {
                                node: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    children: [
                                        "Updated By ",
                                        data === null || data === void 0 ? void 0 : data.created_by_name
                                    ]
                                }),
                                id: "created_by_name"
                            },
                            {
                                node: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    children: (0,_vahak_core_ui_dist_methods_time__WEBPACK_IMPORTED_MODULE_7__/* .formatDate */ .p6)(new Date((ref2 = data === null || data === void 0 ? void 0 : data.created_at) !== null && ref2 !== void 0 ? ref2 : "-"), "MMMM DD, YYYY at h:mm a")
                                }),
                                id: "created_at"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    gap: 8,
                    flexWrap: "wrap",
                    children: list === null || list === void 0 ? void 0 : list.filter(function(val) {
                        return !!(val === null || val === void 0 ? void 0 : val.id);
                    }).map(function(item, ix) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_posting_form_common_posting_chip_PostingChip__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            weight: "medium",
                            children: item === null || item === void 0 ? void 0 : item.value
                        }, item === null || item === void 0 ? void 0 : item.label);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    weight: "medium",
                    color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].GREY_600 */ .Z.GREY_600,
                    children: (data === null || data === void 0 ? void 0 : data.other) ? "Remarks: ".concat(data === null || data === void 0 ? void 0 : data.other) : ""
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DispositionCard);


/***/ }),

/***/ 65302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ MarketplaceLoadCardShimmer; },
  "Z": function() { return /* binding */ load_card_MarketplaceLoadCard; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/marketplace-new/load-card/MarketplaceLoadCard.module.scss
var MarketplaceLoadCard_module = __webpack_require__(50307);
var MarketplaceLoadCard_module_default = /*#__PURE__*/__webpack_require__.n(MarketplaceLoadCard_module);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var constants = __webpack_require__(94204);
// EXTERNAL MODULE: ./components/admin/IfCanAccess/IfCanAccess.tsx
var IfCanAccess = __webpack_require__(6632);
// EXTERNAL MODULE: ./components/posting-form/common/src-dest/SourceDestination.tsx
var SourceDestination = __webpack_require__(65448);
// EXTERNAL MODULE: ../core-ui/dist/components/LineDivider/index.js
var LineDivider = __webpack_require__(25354);
// EXTERNAL MODULE: ./components/marketplace-new/marketplace-load-lorry-quick-info/MarketplaceLoadLorryQuickInfo.tsx + 4 modules
var MarketplaceLoadLorryQuickInfo = __webpack_require__(17238);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ./components/marketplace-new/loading-time-badge/LoadingTimeBadge.tsx + 1 modules
var LoadingTimeBadge = __webpack_require__(4546);
// EXTERNAL MODULE: ./components/marketplace-new/user-profile-info/UserProfileInfo.tsx
var UserProfileInfo = __webpack_require__(32841);
// EXTERNAL MODULE: ./components/marketplace-new/expected-price-and-bid-now/ExpectedPriceAndBidNow.module.scss
var ExpectedPriceAndBidNow_module = __webpack_require__(35145);
var ExpectedPriceAndBidNow_module_default = /*#__PURE__*/__webpack_require__.n(ExpectedPriceAndBidNow_module);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ../core-ui/dist/components/Chip/index.js
var Chip = __webpack_require__(93834);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/index.js
var dist_constants = __webpack_require__(73242);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/index.js
var Button = __webpack_require__(32450);
// EXTERNAL MODULE: ../core-ui/dist/methods/common.js
var common = __webpack_require__(28052);
// EXTERNAL MODULE: ../core/dist/hooks/useCsDashboard.js
var useCsDashboard = __webpack_require__(68191);
;// CONCATENATED MODULE: ../core/dist/icons/ribbon-best-price.svg
var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgRibbonBestPrice(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 110,
    height: 22,
    viewBox: "0 0 110 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M.318 4a4 4 0 014-4h101.078c1.633 0 2.578 1.853 1.618 3.175L101.335 11l5.679 7.825c.96 1.322.015 3.175-1.618 3.175H4.318a4 4 0 01-4-4V4z",
    fill: "#0EA546"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M31.015 15l1.328-8h3.062c.578 0 1.044.091 1.399.273.354.18.6.426.738.739.14.312.177.666.11 1.062-.055.323-.165.6-.329.832-.161.23-.36.417-.593.563a2.542 2.542 0 01-.754.308l-.016.079a1.463 1.463 0 011.305.93c.12.286.147.63.082 1.034-.07.414-.233.787-.489 1.117a2.593 2.593 0 01-1.039.778c-.435.19-.957.285-1.566.285h-3.238zm1.652-1.21h1.559c.523 0 .919-.101 1.187-.302.268-.203.429-.463.48-.781.04-.237.016-.45-.07-.64a.955.955 0 00-.425-.454c-.199-.112-.446-.168-.743-.168h-1.601l-.387 2.344zm.566-3.388h1.434c.25 0 .482-.045.695-.136.216-.094.396-.226.54-.395.145-.172.235-.375.269-.61.055-.31-.01-.564-.195-.765-.185-.2-.49-.3-.914-.3h-1.47l-.359 2.206zM38.244 15l1.328-8h5.203l-.203 1.215h-3.754l-.359 2.172h3.484l-.203 1.215h-3.484l-.36 2.183h3.786L43.478 15h-5.234zm11.983-5.762c.01-.362-.1-.639-.332-.832-.23-.192-.56-.289-.989-.289-.302 0-.569.046-.8.137-.23.088-.415.212-.555.371-.14.156-.228.335-.262.535a.707.707 0 00.043.43.812.812 0 00.262.312c.12.086.255.158.406.215.154.057.31.106.469.145l.718.187c.287.07.56.166.82.285.261.118.486.269.677.454.192.182.333.402.422.66.088.257.102.56.042.906a2.54 2.54 0 01-.566 1.238 2.984 2.984 0 01-1.172.832c-.482.198-1.043.297-1.683.297-.62 0-1.144-.096-1.57-.289-.428-.195-.74-.478-.938-.848-.196-.37-.258-.819-.188-1.347h1.426c-.029.278.017.51.137.695.122.185.298.323.527.414.23.091.495.137.797.137.315 0 .6-.047.855-.14.256-.097.464-.23.625-.4.164-.171.265-.372.301-.6.037-.207.007-.378-.09-.516a1.058 1.058 0 00-.449-.344c-.2-.094-.44-.177-.719-.25l-.867-.235c-.627-.171-1.104-.43-1.43-.773-.322-.344-.437-.802-.343-1.375.078-.474.274-.887.59-1.238.315-.354.71-.63 1.183-.825a3.995 3.995 0 011.555-.296c.568 0 1.048.099 1.441.296.396.198.685.474.867.829.185.351.247.759.184 1.222h-1.394zm2.616-1.023L53.046 7h6.383l-.203 1.215h-2.473L55.628 15H54.19l1.125-6.785h-2.472zM62.06 15l1.328-8h3c.614 0 1.112.115 1.492.344.38.226.644.54.793.941.148.399.18.853.094 1.363a3.206 3.206 0 01-.551 1.368 2.932 2.932 0 01-1.113.941c-.461.227-1 .34-1.618.34h-1.988l.2-1.192h1.792c.36 0 .664-.062.914-.187.253-.125.452-.297.598-.516.146-.218.242-.47.289-.754.044-.283.03-.533-.043-.75a.897.897 0 00-.426-.503c-.208-.123-.493-.184-.855-.184h-1.328L63.508 15H62.06zm7.068 0l1.328-8h3c.615 0 1.113.107 1.496.32.383.214.65.513.8.899.152.383.184.83.099 1.34a3 3 0 01-.547 1.332 2.748 2.748 0 01-1.106.87c-.455.206-.99.31-1.605.31h-2.137l.203-1.204h1.945c.36 0 .662-.05.907-.148.245-.102.437-.249.578-.442a1.65 1.65 0 00.285-.718c.044-.284.027-.526-.05-.727a.824.824 0 00-.434-.46c-.211-.108-.496-.161-.856-.161h-1.328L70.577 15h-1.45zm4.734-3.625L75.242 15h-1.618l-1.344-3.625h1.582zM79.102 7l-1.328 8h-1.449l1.328-8h1.45zm7.96 2.7h-1.437c0-.24-.04-.453-.117-.637a1.344 1.344 0 00-.328-.477 1.372 1.372 0 00-.5-.293 1.922 1.922 0 00-.64-.102c-.449 0-.866.114-1.25.34a2.87 2.87 0 00-.981.989c-.269.43-.455.951-.559 1.566-.096.599-.087 1.1.027 1.504.117.403.32.708.61.914.289.203.64.305 1.054.305.253 0 .495-.032.727-.094a2.37 2.37 0 00.64-.285 2.21 2.21 0 00.52-.465 2.05 2.05 0 00.352-.621h1.457a4.002 4.002 0 01-1.364 1.957 3.873 3.873 0 01-2.398.809c-.716 0-1.33-.167-1.84-.5-.508-.337-.872-.817-1.094-1.442-.22-.628-.26-1.379-.117-2.254.143-.851.42-1.577.828-2.176a4.233 4.233 0 011.504-1.37 4.003 4.003 0 011.918-.477c.453 0 .865.062 1.235.187.372.125.691.309.957.55.265.24.467.535.605.884.14.346.205.742.192 1.187zm.457 5.3l1.328-8h5.203l-.203 1.215h-3.754l-.36 2.172h3.485l-.203 1.215H89.53l-.36 2.183h3.786L92.753 15h-5.234zM23.544 16.133c.053-.456-.328-.934-.511-1.271.29-.145.592-.4.669-.755.125-.581.203-1.13-.236-1.482a1.101 1.101 0 00-.14-.083c.264-.349.474-.73.4-1.174-.064-.413-.378-.574-.688-.857.036-.08.179-.38.205-.463.263-.785.074-1.406-.4-1.96-.345-.402-.988-.603-1.968-.614-.524-.007-1.15.04-1.865.141.096-.688.153-1.604-.02-2.45-.137-.671-.405-1.386-.65-1.739-.27-.388-.627-.629-1.035-.698-.38-.064-.77.034-1.098.274a1.734 1.734 0 00-.689 1.304l-.088 1.43.004.045c.028.397-.097 1.518-1.86 3.319-.07.07-.135.145-.196.224l-.172.198-.016-.02a1.653 1.653 0 00-1.16-.503l-1.287-.025a1.656 1.656 0 00-1.174.457 1.625 1.625 0 00-.5 1.149l-.068 4.882a1.64 1.64 0 00.305.974 1.665 1.665 0 001.322.696l1.287.025a1.646 1.646 0 001.33-.63 1.562 1.562 0 00.805.45c2.285.467 4.205.719 5.707.748 1.527.03 2.565-.167 3.171-.601.357-.257.57-.6.616-.99z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M12.321 16.026a.742.742 0 01-.228.172.671.671 0 01-.268.067l-1.206.043a.636.636 0 01-.488-.202.743.743 0 01-.195-.523l.082-4.969a.827.827 0 01.212-.538.75.75 0 01.229-.171.676.676 0 01.267-.067l1.206-.044a.641.641 0 01.556.288c.086.125.13.279.128.438l-.083 4.968a.82.82 0 01-.212.538zM22.458 15.925c.065-.266-.007-.774-.198-.826l-.746-.25.784-.414c.165-.136.28-.346.34-.624.072-.328.042-.59-.087-.778a.678.678 0 00-.182-.177l-.82-.274.796-.457c.258-.2.366-.444.322-.722.007-.53-.21-.603-.49-.7l-.808-.267.58-.29c.083-.11.238-.346.28-.477.088-.281.124-.7-.218-1.104-.084-.1-.651-.57-3.573-.052l-.648.115.133-.648c.122-.594.297-1.737.1-2.73-.13-.66-.367-1.218-.493-1.403-.087-.126-.231-.284-.43-.317a.535.535 0 00-.406.114.855.855 0 00-.323.64l-.09 1.374c.046.788-.285 2.119-2.107 4.005l-.076.094a1.944 1.944 0 00-.444 1.194l-.078 4.218c-.009.435.23.8.566.867 2.202.446 4.044.682 5.473.703.726.011 2.029-.032 2.596-.445.199-.146.237-.28.247-.369z",
    fill: "#0F863C"
  })));
}

/* harmony default export */ var ribbon_best_price = (SvgRibbonBestPrice);
;// CONCATENATED MODULE: ./components/marketplace-new/expected-price-and-bid-now/ExpectedPriceAndBidNow.tsx


//Style

//Components











var ExpectedPriceAndBidNow = function(param) {
    var id = param.id, onBidNowClick = param.onBidNowClick, expectedPrice = param.expectedPrice, paymentType = param.paymentType, advanceAmount = param.advanceAmount, pricePerTonPerKm = param.pricePerTonPerKm, additionalCharge = param.additionalCharge, isBestPrice = param.isBestPrice;
    var checkPermission = (0,useCsDashboard/* useCsDashboard */.Z)().checkPermission;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ExpectedPriceAndBidNow_module_default()).main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
            className: (ExpectedPriceAndBidNow_module_default()).container,
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                    flexDirection: "column",
                    gap: 6,
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ExpectedPriceAndBidNow_module_default()).expectedAmount,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                                gap: 5,
                                id: "".concat(id, "--expectedPrice"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: colors/* default.GREY_1000 */.Z.GREY_1000,
                                        size: "m",
                                        weight: "semibold",
                                        children: expectedPrice ? (0,common/* getPriceString */.rD)(expectedPrice) : "--"
                                    }),
                                    isBestPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ribbon_best_price, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: !!expectedPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                            color: "grey",
                                            filled: true,
                                            radius: 30,
                                            size: "auto",
                                            padded: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                size: "xs",
                                                weight: "semibold",
                                                children: "Expected rate"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* VerticalFlex */.vs, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ExpectedPriceAndBidNow_module_default()).expectedAmount,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                                        id: "".concat(id, "--pricePerTonPerKm"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            color: colors/* default.GREY_600 */.Z.GREY_600,
                                            size: "xs",
                                            weight: "semibold",
                                            children: [
                                                "(",
                                                paymentType === constants/* PAYMENT_TYPE.Advance */.V_z.Advance ? "".concat(advanceAmount, "% ").concat(constants/* PAYMENT_TYPE_MAP */.dhr[paymentType]) : constants/* PAYMENT_TYPE_MAP */.dhr[paymentType],
                                                " ",
                                                pricePerTonPerKm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            color: colors/* default.GREY_300 */.Z.GREY_300,
                                                            size: "xs",
                                                            children: dist_constants/* DotSymbol */.ud
                                                        }),
                                                        " ",
                                                        (0,common/* getPriceString */.rD)(pricePerTonPerKm),
                                                        " / tonne-km"
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                ")"
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ExpectedPriceAndBidNow_module_default()).expectedAmount,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: colors/* default.GREY_600 */.Z.GREY_600,
                                        size: "xs",
                                        children: !!additionalCharge ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                "(Additional Charges ",
                                                (0,common/* getPriceString */.rD)(additionalCharge),
                                                ")"
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: "(Inclusive of all charges)"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                !!onBidNowClick && /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                    action: "",
                    allowCustomer: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ExpectedPriceAndBidNow_module_default()).bidNowBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            isRounded: true,
                            width: 100,
                            onClick: onBidNowClick,
                            id: "".concat(id, "--bidNow"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                size: "sm",
                                children: "Bid Now"
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var expected_price_and_bid_now_ExpectedPriceAndBidNow = (ExpectedPriceAndBidNow);

// EXTERNAL MODULE: ../core/dist/components/dropdown/Dropdown.js + 1 modules
var Dropdown = __webpack_require__(92266);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useToggleModalWithLocalState.js
var useToggleModalWithLocalState = __webpack_require__(8779);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ./constants/adminOperation.ts
var adminOperation = __webpack_require__(40223);
// EXTERNAL MODULE: ../core/dist/standard-icons/options.svg
var options = __webpack_require__(53272);
;// CONCATENATED MODULE: ../core/dist/icons/verifiedTag.svg
var verifiedTag_path, _g, verifiedTag_path2, _defs;

function verifiedTag_extends() { verifiedTag_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return verifiedTag_extends.apply(this, arguments); }



function SvgVerifiedTag(props) {
  return /*#__PURE__*/react.createElement("svg", verifiedTag_extends({
    width: 92,
    height: 24,
    viewBox: "0 0 92 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), verifiedTag_path || (verifiedTag_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 0h92l-9.984 12L92 24H0V0z",
    fill: "#DBEFFF"
  })), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#verifiedTag_svg__clip0_8902_3150)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M19.248 4.87a2.198 2.198 0 013.504 0c.48.633 1.264.958 2.05.85a2.198 2.198 0 012.478 2.477 2.198 2.198 0 00.85 2.051 2.198 2.198 0 010 3.504 2.198 2.198 0 00-.85 2.05 2.198 2.198 0 01-2.477 2.478 2.198 2.198 0 00-2.051.85 2.198 2.198 0 01-3.504 0 2.198 2.198 0 00-2.05-.85 2.198 2.198 0 01-2.478-2.477 2.198 2.198 0 00-.85-2.051 2.198 2.198 0 010-3.504c.633-.48.958-1.264.85-2.05a2.198 2.198 0 012.477-2.478 2.198 2.198 0 002.051-.85z",
    fill: "#2355FC"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.65 8.885a.913.913 0 01.073 1.289l-4.346 4.868a.913.913 0 01-1.362 0l-1.738-1.947a.913.913 0 111.361-1.216l1.058 1.184 3.665-4.105a.913.913 0 011.29-.073z",
    fill: "#fff"
  }))), verifiedTag_path2 || (verifiedTag_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M34.69 8.727l1.893 5.725h.075l1.889-5.725h1.449L37.432 16h-1.627l-2.56-7.273h1.445zm8.336 7.38c-.547 0-1.02-.114-1.417-.341-.396-.23-.7-.554-.913-.973-.213-.422-.32-.918-.32-1.488 0-.561.107-1.054.32-1.478.216-.426.516-.757.902-.994.386-.239.84-.359 1.36-.359.336 0 .654.055.952.164.3.106.566.272.795.497.232.225.415.511.547.86.133.345.2.757.2 1.235v.394H40.98v-.866h3.239a1.384 1.384 0 00-.16-.657 1.161 1.161 0 00-.437-.458 1.228 1.228 0 00-.646-.167c-.263 0-.494.064-.693.192a1.321 1.321 0 00-.465.497 1.431 1.431 0 00-.167.67v.757c0 .318.058.59.174.817.116.225.279.398.487.519.208.118.452.177.731.177.188 0 .357-.026.508-.078.152-.054.283-.134.394-.238a.992.992 0 00.253-.387l1.2.135a1.87 1.87 0 01-.433.83c-.211.235-.481.418-.81.548a3.103 3.103 0 01-1.13.192zM46.839 16v-5.454h1.246v.909h.057c.1-.315.27-.558.511-.728.244-.173.522-.26.835-.26.07 0 .15.004.238.011.09.005.164.013.223.025v1.182a1.345 1.345 0 00-.259-.05 2.382 2.382 0 00-.337-.024 1.3 1.3 0 00-.632.152c-.185.1-.33.238-.437.416a1.17 1.17 0 00-.16.614V16H46.84zm4.264 0v-5.454h1.286V16h-1.286zm.647-6.229a.75.75 0 01-.526-.202.652.652 0 01-.22-.494c0-.194.073-.358.22-.493a.743.743 0 01.526-.206c.206 0 .38.068.525.206.147.135.22.3.22.493a.653.653 0 01-.22.494.742.742 0 01-.525.202zm5.024.774v.995h-3.225v-.994h3.225zM54.355 16v-5.97c0-.366.076-.672.228-.916.154-.244.36-.426.617-.547.259-.12.545-.18.86-.18.222 0 .42.017.593.053.173.035.3.067.383.096l-.255.994a2.23 2.23 0 00-.206-.05 1.245 1.245 0 00-.277-.028c-.24 0-.409.058-.508.174-.097.113-.146.277-.146.49V16h-1.289zm3.725 0v-5.454h1.286V16H58.08zm.647-6.229a.75.75 0 01-.526-.202.652.652 0 01-.22-.494c0-.194.073-.358.22-.493a.743.743 0 01.526-.206c.206 0 .38.068.525.206.147.135.22.3.22.493a.652.652 0 01-.22.494.742.742 0 01-.525.202zm4.676 6.335c-.547 0-1.02-.113-1.417-.34-.396-.23-.7-.554-.913-.973-.213-.422-.32-.918-.32-1.488 0-.561.107-1.054.32-1.478.215-.426.516-.757.902-.994.386-.239.84-.359 1.36-.359.336 0 .654.055.952.164.3.106.566.272.795.497.232.225.415.511.547.86.133.345.2.757.2 1.235v.394h-4.472v-.866h3.239a1.382 1.382 0 00-.16-.657 1.161 1.161 0 00-.437-.458 1.227 1.227 0 00-.646-.167c-.263 0-.494.064-.693.192a1.322 1.322 0 00-.465.497 1.431 1.431 0 00-.167.67v.757c0 .318.058.59.174.817.116.225.279.398.487.519.208.118.452.177.731.177.187 0 .357-.026.508-.078a1.13 1.13 0 00.394-.238.992.992 0 00.252-.387l1.2.135c-.075.317-.22.594-.433.83-.21.235-.48.418-.81.548-.328.128-.705.192-1.128.192zm5.837-.01c-.429 0-.812-.11-1.15-.33-.34-.22-.607-.54-.803-.96-.197-.418-.295-.927-.295-1.526 0-.606.1-1.118.298-1.534.201-.42.472-.735.813-.948a2.09 2.09 0 011.14-.324c.32 0 .583.055.789.164.206.106.369.235.49.387.12.149.214.29.28.422h.053v-2.72h1.29V16H70.88v-.86h-.078a2.193 2.193 0 01-.287.423 1.58 1.58 0 01-.498.377c-.206.104-.465.156-.777.156zm.358-1.055c.273 0 .505-.073.696-.22.192-.15.338-.356.437-.621.1-.266.15-.574.15-.927 0-.353-.05-.66-.15-.92a1.31 1.31 0 00-.433-.607 1.12 1.12 0 00-.7-.217c-.286 0-.525.075-.717.224-.192.149-.336.355-.433.618a2.595 2.595 0 00-.146.902c0 .34.049.645.146.912.1.265.245.475.437.629.194.151.432.227.713.227z",
    fill: "#2355FC"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "verifiedTag_svg__clip0_8902_3150"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M13 4h12a4 4 0 014 4v8a4 4 0 01-4 4h-8a4 4 0 01-4-4V4z",
    fill: "#fff"
  })))));
}

/* harmony default export */ var verifiedTag = (SvgVerifiedTag);
;// CONCATENATED MODULE: ../core/dist/standard-icons/shareIcon.svg
var shareIcon_path;

function shareIcon_extends() { shareIcon_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shareIcon_extends.apply(this, arguments); }



function SvgShareIcon(props) {
  return /*#__PURE__*/react.createElement("svg", shareIcon_extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), shareIcon_path || (shareIcon_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.038 3.924c0-1.13.926-2.057 2.057-2.057 1.131 0 2.057.926 2.057 2.057 0 1.13-.926 2.057-2.057 2.057-.49 0-.935-.181-1.29-.47L5.978 7.934c.052.179.089.365.089.56 0 .156-.02.306-.054.452l3.926 2.154a2.042 2.042 0 011.385-.549c1.13 0 2.057.927 2.057 2.058 0 1.13-.927 2.057-2.057 2.057a2.064 2.064 0 01-2.057-2.057c0-.267.055-.52.148-.754L5.61 9.769a2.048 2.048 0 01-1.6.783 2.064 2.064 0 01-2.058-2.057c0-1.13.927-2.057 2.058-2.057.606 0 1.149.272 1.526.694l3.7-2.344a2.027 2.027 0 01-.198-.864z",
    fill: "#A4A4A4"
  })));
}

/* harmony default export */ var shareIcon = (SvgShareIcon);
// EXTERNAL MODULE: ../core/dist/icons/call-circle.svg
var call_circle = __webpack_require__(72020);
// EXTERNAL MODULE: ../core/dist/icons/location-grey.svg
var location_grey = __webpack_require__(18230);
// EXTERNAL MODULE: ./components/admin/badge/AgentBadge.tsx + 7 modules
var AgentBadge = __webpack_require__(65643);
// EXTERNAL MODULE: ../core-ui/dist/components/IconWrapper/index.js
var IconWrapper = __webpack_require__(60054);
// EXTERNAL MODULE: ./hooks/useGetContactDetails.tsx + 1 modules
var useGetContactDetails = __webpack_require__(51473);
// EXTERNAL MODULE: ./constants/c2c-reference-type.ts
var c2c_reference_type = __webpack_require__(85820);
// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ../core/dist/_services/index.js + 6 modules
var _services = __webpack_require__(96122);
// EXTERNAL MODULE: ../core/dist/components/skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(71155);
// EXTERNAL MODULE: ./methods/admin.ts
var admin = __webpack_require__(90756);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../core-ui/dist/components/ModalOrBottomSheetWrapper/index.js
var ModalOrBottomSheetWrapper = __webpack_require__(9937);
// EXTERNAL MODULE: ../core-ui/dist/components/TextCTA/index.js
var TextCTA = __webpack_require__(14342);
// EXTERNAL MODULE: ../core-ui/dist/hooks/index.js + 3 modules
var hooks = __webpack_require__(95385);
// EXTERNAL MODULE: ./components/helper/StopPropagation.tsx
var StopPropagation = __webpack_require__(77845);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(77149);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./services/load/useGetLoadStops.tsx
var useGetLoadStops = __webpack_require__(38038);
// EXTERNAL MODULE: ../core-ui/dist/components/DotLoader/index.js + 2 modules
var DotLoader = __webpack_require__(97871);
// EXTERNAL MODULE: ./components/listing-v2/load-card/stops-view/LoadStopsList.module.scss
var LoadStopsList_module = __webpack_require__(43916);
var LoadStopsList_module_default = /*#__PURE__*/__webpack_require__.n(LoadStopsList_module);
// EXTERNAL MODULE: ./services/company/useGetLatAndLongBasedOnPlaceIdV1.ts
var useGetLatAndLongBasedOnPlaceIdV1 = __webpack_require__(12461);
// EXTERNAL MODULE: ../core/dist/standard-icons/source.svg
var source = __webpack_require__(48743);
// EXTERNAL MODULE: ../core/dist/standard-icons/destination.svg
var destination = __webpack_require__(98517);
// EXTERNAL MODULE: ../core/dist/icons/google-map-icon.svg
var google_map_icon = __webpack_require__(68916);
// EXTERNAL MODULE: ./methods/maps.ts
var maps = __webpack_require__(92322);
;// CONCATENATED MODULE: ./components/listing-v2/load-card/stops-view/LoadStopsList.tsx






















var LoadStopsList = function(props) {
    var ref, ref1;
    var loadId = props.loadId;
    var ref2 = (0,react.useState)(), listItem = ref2[0], setListItem = ref2[1];
    var ref3 = (0,useGetLatAndLongBasedOnPlaceIdV1/* useGetLatAndLongBasedOnPlaceIdV1 */.Q)(), getLatAndLong = ref3.mutateAsync;
    // const [totalDistance, setTotalDistance] = useState( );
    var ref4 = (0,react.useState)({
        isLoading: true
    }), actionState = ref4[0], setActionState = ref4[1];
    var response = (0,useGetLoadStops/* useGetLoadStops */.b)({
        loadId: loadId
    }, (0,_object_spread/* default */.Z)({
        enabled: !!loadId
    }, constants/* NoSuccessErrorHandler */.jtj));
    var _stopList = (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.stops) || [];
    (0,react.useEffect)(function() {
        var method = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var __stopList, src, rest, dest, waypoints, ref, stopsInfo, formatStopInfo, result;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            __stopList = (0,_to_array/* default */.Z)(_stopList), src = __stopList[0], rest = __stopList.slice(1);
                            dest = rest.pop();
                            waypoints = rest;
                            try {
                                ;
                                stopsInfo = (ref = (0,_to_consumable_array/* default */.Z)(waypoints)) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
                                    return Number(a.sequence) - Number(b.sequence);
                                });
                                formatStopInfo = function(info) {
                                    var ref = info || {}, description = ref.description, address = ref.address, latitude = ref.latitude, longitude = ref.longitude;
                                    return {
                                        text: (0,methods/* getJoinedStringFromArray */.D$)([
                                            description,
                                            address
                                        ], ", ", true),
                                        latAndLng: [
                                            latitude,
                                            longitude
                                        ]
                                    };
                                };
                                result = [
                                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formatStopInfo(src)), {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(source/* default */.Z, {})
                                    })
                                ].concat((0,_to_consumable_array/* default */.Z)(stopsInfo.map(function(v, ix) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formatStopInfo(v)), {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (LoadStopsList_module_default()).dot,
                                            children: ix + 1
                                        })
                                    });
                                })), [
                                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formatStopInfo(dest)), {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(destination/* default */.Z, {})
                                    })
                                ]);
                                // .map((item, ix, arr) => {
                                //     const lastLocationLatLng = arr.at(ix - 1)?.latAndLng;
                                //     return {
                                //         ...item,
                                //         ...(item.latAndLng &&
                                //             lastLocationLatLng && {
                                //                 distanceInKm: getAerialDistanceInKm(item.latAndLng, lastLocationLatLng)
                                //             })
                                //     };
                                // }) as ListItem[];
                                // setTotalDistance(
                                //     result?.reduce((previousValue: number, currentValue: ListItem) => {
                                //         return previousValue + Number(currentValue?.distanceInKm) || 0;
                                //     }, 0)
                                // );
                                setListItem(result);
                            } catch (error) {
                                console.error(error);
                            } finally{
                                setActionState({
                                    isLoading: false
                                });
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function method() {
                return _ref.apply(this, arguments);
            };
        }();
        (_stopList === null || _stopList === void 0 ? void 0 : _stopList.length) && method();
    }, [
        _stopList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LoadStopsList_module_default()).main,
        children: (actionState === null || actionState === void 0 ? void 0 : actionState.isLoading) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
            justifyContent: "center",
            style: {
                padding: 20
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DotLoader["default"], {})
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LoadStopsList_module_default()).locations,
                    children: listItem === null || listItem === void 0 ? void 0 : listItem.map(function(item, ix) {
                        var allowOpenInGoogleMap = ix == 0;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LoadStopsList_module_default()).locationDividerWrapper,
                                children: [
                                    ix > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (LoadStopsList_module_default()).divider
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        className: (LoadStopsList_module_default()).location
                                    }, allowOpenInGoogleMap && {
                                        onClick: function() {
                                            return (0,maps/* openGoogleMapsRoute */.Y)([
                                                item === null || item === void 0 ? void 0 : item.latAndLng
                                            ]);
                                        },
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }), {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (LoadStopsList_module_default()).locationIcon,
                                                children: item === null || item === void 0 ? void 0 : item.icon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                                                gap: 5,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        weight: "semibold",
                                                        children: item === null || item === void 0 ? void 0 : item.text
                                                    }),
                                                    allowOpenInGoogleMap && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                                                        width: 20,
                                                        height: 20,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(google_map_icon/* default */.Z, {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }))
                                ]
                            })
                        });
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        outlined: true,
                        color: "green",
                        leftNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(google_map_icon/* default */.Z, {}),
                        radius: 60,
                        onClick: function() {
                            var list = listItem === null || listItem === void 0 ? void 0 : listItem.map(function(v) {
                                return v === null || v === void 0 ? void 0 : v.latAndLng;
                            });
                            (list === null || list === void 0 ? void 0 : list.length) && (0,maps/* openGoogleMapsRoute */.Y)(list);
                        },
                        children: "View in Google map"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var stops_view_LoadStopsList = (LoadStopsList);

// EXTERNAL MODULE: ./hooks/useValidateUserStatus.ts + 1 modules
var useValidateUserStatus = __webpack_require__(4641);
;// CONCATENATED MODULE: ./components/listing-v2/load-card/stops-view/LoadStopsPopup.tsx












var LoadStopsPopup = function(_param) {
    var _actionText = _param.actionText, actionText = _actionText === void 0 ? "Multi-stop" : _actionText, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "actionText"
    ]);
    var popupState = (0,hooks/* useToggleModalWithLocalState */.A$)();
    var loginCheck = (0,useValidateUserStatus/* default */.Z)().loginCheck;
    var wrappedCtaAction = function() {
        loginCheck() && (popupState === null || popupState === void 0 ? void 0 : popupState.openModal());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StopPropagation/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCTA/* default */.Z, {
                onClick: wrappedCtaAction,
                underline: true,
                weight: "medium",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    noWrap: true,
                    children: actionText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrBottomSheetWrapper["default"], {
                isOpen: popupState === null || popupState === void 0 ? void 0 : popupState.isModalOpen,
                onToggle: popupState === null || popupState === void 0 ? void 0 : popupState.toggleModal,
                titleText: "Stop locations",
                renderFooter: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-popup-footer": true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        blockBtn: true,
                        onClick: function() {
                            return popupState.closeModal();
                        },
                        children: "Okay"
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stops_view_LoadStopsList, (0,_object_spread/* default */.Z)({}, restProps))
            })
        ]
    });
};
/* harmony default export */ var stops_view_LoadStopsPopup = (LoadStopsPopup);

// EXTERNAL MODULE: ./components/admin/load/load-disable/DisableLoadWithRemarks.tsx
var DisableLoadWithRemarks = __webpack_require__(68079);
;// CONCATENATED MODULE: ./components/marketplace-new/load-card/OdcDetails.tsx




var OdcDetails = function(param) {
    var _height = param.height, height = _height === void 0 ? 0 : _height, _length = param.length, length = _length === void 0 ? 0 : _length, _breadth = param.breadth, breadth = _breadth === void 0 ? 0 : _breadth, isOdc = param.isOdc;
    if (!isOdc) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            size: "xs",
            color: colors/* default.GREY_500 */.Z.GREY_500,
            weight: "medium",
            children: [
                "ODC: ",
                "".concat(length, "L x ").concat(breadth, "B x ").concat(height, "H (in mts)")
            ]
        })
    });
};
/* harmony default export */ var load_card_OdcDetails = (OdcDetails);

// EXTERNAL MODULE: ./components/admin/ticket-system-helper/constants.ts
var ticket_system_helper_constants = __webpack_require__(60280);
;// CONCATENATED MODULE: ./components/marketplace-new/load-card/MarketplaceLoadCard.tsx





//Style

//Constant

//Components











//Hooks


//Types && constants


//Assets




















var MarketplaceLoadCard = function(param) {
    var id = param.id, data = param.data, onBidNowClick = param.onBidNowClick, handleClickProfile = param.handleClickProfile, evenSourceScreen = param.evenSourceScreen, _mobileResponsive = param.mobileResponsive, mobileResponsive = _mobileResponsive === void 0 ? true : _mobileResponsive, onRefetch = param.onRefetch, flags = param.flags, destRouteLanLng = param.destRouteLanLng, _c2cReferenceType = param.c2cReferenceType, c2cReferenceType = _c2cReferenceType === void 0 ? c2c_reference_type/* C2C_REFERENCE_TYPE.LOAD_MARKETPLACE */.d.LOAD_MARKETPLACE : _c2cReferenceType, _showCompanyInfo = param.showCompanyInfo, showCompanyInfo = _showCompanyInfo === void 0 ? false : _showCompanyInfo;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var ref20 = (0,react.useContext)(app_context/* AppContext */.Il), setShowShareModalPopup = ref20.setShowShareModalPopup, companyId = ref20.companyId, isCsDashboardUser = ref20.isCsDashboardUser, route = ref20.route;
    var toggleShareModal = function() {
        var ref, ref1, ref2;
        setShowShareModalPopup === null || setShowShareModalPopup === void 0 ? void 0 : setShowShareModalPopup({
            isVisible: true,
            mktType: "load",
            data: {
                id: data.load_detail.id,
                source: data.load_detail.source_city_name,
                destination: (ref = data.load_detail.destination) === null || ref === void 0 ? void 0 : ref.split("(")[0],
                quantity: data.load_detail.quantity,
                lorry_type_id: (ref2 = (0,constants/* getLorryDetailsByType */.X9c)(data === null || data === void 0 ? void 0 : (ref1 = data.load_detail) === null || ref1 === void 0 ? void 0 : ref1.lorry_type_id)) === null || ref2 === void 0 ? void 0 : ref2.id,
                lorry_type_text: data.load_detail.lorry_type,
                transporter_name: data.load_detail.destination_city_name,
                oppositeCompanyId: companyId,
                loadCardData: data
            }
        });
    // if (isTso) {
    //     trackClick("share_clicked");
    // }
    };
    var ref21 = (0,useToggleModalWithLocalState/* useToggleModalWithLocalState */.A)(false), isAdminOptionMenuOpen = ref21.isModalOpen, closeAdminOptionMenu = ref21.closeModal, toggleAdminOptionMenu = ref21.toggleModal;
    var ref22 = (0,useToggleModalWithLocalState/* useToggleModalWithLocalState */.A)(false), isLoadDeletionModalOpen = ref22.isModalOpen, openLoadDeletionModal = ref22.openModal, closeLoadDeletionModal = ref22.closeModal;
    var connectC2C = (0,useGetContactDetails/* useGetContactDetails */.m)(data === null || data === void 0 ? void 0 : (ref = data.company_detail) === null || ref === void 0 ? void 0 : ref.id.toString()).connectC2C;
    var _onClickGetContactTso = function() {
        connectC2C({
            callerId: Number(companyId),
            calleeId: Number(data.company_detail.id.toString()),
            referenceId: Number(data.load_detail.id),
            referenceType: c2cReferenceType
        });
        handleTracking === null || handleTracking === void 0 ? void 0 : handleTracking("call_initiated");
    };
    var sendGAandMoEngageEvent = (0,_services/* useEventTrackerService */.fQ)().sendGAandMoEngageEvent;
    var handleTracking = function(name) {
        var additionalData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var ref, ref1, ref2;
        var _payment_type;
        var eventData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            source_screen: evenSourceScreen || "tso_load_market",
            tso_tagged: !!(data === null || data === void 0 ? void 0 : (ref = data.agent_detail) === null || ref === void 0 ? void 0 : ref.agent_name)
        }, !!(data === null || data === void 0 ? void 0 : (ref1 = data.agent_detail) === null || ref1 === void 0 ? void 0 : ref1.agent_name) && {
            tagged_tso_id: data === null || data === void 0 ? void 0 : (ref2 = data.agent_detail) === null || ref2 === void 0 ? void 0 : ref2.user_id
        }, additionalData), {
            load_id: data.load_detail.id,
            is_load_verified: data.load_detail.is_verified,
            from_location: data.load_detail.source,
            to_location: data.load_detail.destination,
            material: data.load_detail.material_type,
            quantity: data.load_detail.quantity,
            required_vehicle_type: data.load_detail.lorry_type_id,
            expected_price: data.load_detail.amount,
            expected_price_type: (0,methods/* stringOperations */.$M)((_payment_type = constants/* EXPECTED_AMOUNT_TYPE */.qsA[data.load_detail.payment_type]) !== null && _payment_type !== void 0 ? _payment_type : "", [
                "toLowerCase",
                "replaceSpacesWithUnderscore"
            ])
        });
        sendGAandMoEngageEvent({
            name: name,
            data: eventData
        });
    };
    var isActiveLoad = (data === null || data === void 0 ? void 0 : (ref1 = data.load_detail) === null || ref1 === void 0 ? void 0 : ref1.status) === constants/* LOAD_STATUS.ACTIVE */.Jtx.ACTIVE;
    var isExpiredLoad = (data === null || data === void 0 ? void 0 : (ref2 = data.load_detail) === null || ref2 === void 0 ? void 0 : ref2.status) === constants/* LOAD_STATUS.EXPIRED */.Jtx.EXPIRED;
    var ref23, _total_bids_received;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((MarketplaceLoadCard_module_default()).main, mobileResponsive && (MarketplaceLoadCard_module_default()).mobileResponsive),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MarketplaceLoadCard_module_default()).headerContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        !!data.load_detail.is_verified && /*#__PURE__*/ (0,jsx_runtime.jsx)(verifiedTag, {}),
                        isActiveLoad && ((ref3 = data.load_detail.meta_data) === null || ref3 === void 0 ? void 0 : ref3.limited_bids) && data.load_detail.is_spot_load ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                marginLeft: "15px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                size: "xs",
                                color: colors/* default.ORANGE */.Z.ORANGE,
                                weight: "semibold",
                                children: [
                                    ((ref23 = (ref4 = data.load_detail.meta_data) === null || ref4 === void 0 ? void 0 : ref4.limited_bids) !== null && ref23 !== void 0 ? ref23 : 0) - ((_total_bids_received = data.load_detail.total_bids_received) !== null && _total_bids_received !== void 0 ? _total_bids_received : 0) + "/" + ((ref5 = data.load_detail.meta_data) === null || ref5 === void 0 ? void 0 : ref5.limited_bids),
                                    " ",
                                    "slots remaining"
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        isActiveLoad && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                            alignItems: "center",
                            className: (MarketplaceLoadCard_module_default()).actionBtnWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                                    action: adminOperation/* ADMIN_OPERATION.userLoadLorryAction */.F.userLoadLorryAction,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                                isOpen: isAdminOptionMenuOpen,
                                                DropdownToggleBtn: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (MarketplaceLoadCard_module_default()).langIconWrapper,
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(options/* default */.Z, {})
                                                }),
                                                handleToggle: toggleAdminOptionMenu,
                                                dropdownClassName: (MarketplaceLoadCard_module_default()).adminOptionDropdown,
                                                dropdownToggleClassName: (MarketplaceLoadCard_module_default()).adminOptionDropdownToggle,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        marginLeft: "10px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        fillType: "text",
                                                        size: "s",
                                                        onClick: function() {
                                                            closeAdminOptionMenu();
                                                            openLoadDeletionModal();
                                                        },
                                                        children: "Remove Load"
                                                    })
                                                })
                                            }),
                                            isLoadDeletionModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(DisableLoadWithRemarks/* default */.Z, {
                                                isOpen: isLoadDeletionModalOpen,
                                                onToggle: closeLoadDeletionModal,
                                                loadId: Number(data.load_detail.id),
                                                onRefetch: onRefetch
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MarketplaceLoadCard_module_default()).shareBtn,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        fillType: "text",
                                        onClick: toggleShareModal,
                                        id: "".concat(id, "--share"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            color: dist_constants/* Colors.GREY_400 */.wL.GREY_400,
                                            size: "xs",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(shareIcon, {}),
                                                " Share"
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MarketplaceLoadCard_module_default()).bodyContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceDestination/* default */.Z, (0,_object_spread/* default */.Z)({
                        id: id,
                        source: data.load_detail.source_formatted_address,
                        sourceCity: (data.load_detail.source_locality_name ? data.load_detail.source_locality_name + ", " : "") + data.load_detail.source.split("(")[0],
                        sourceState: data.load_detail.source.split("(")[1].replace(")", ""),
                        destination: data.load_detail.destination_formatted_address,
                        destCity: (data.load_detail.destination_locality_name ? data.load_detail.destination_locality_name + ", " : "") + data.load_detail.destination.split("(")[0],
                        destState: data.load_detail.destination.split("(")[1].replace(")", ""),
                        distanceInKm: Math.ceil(data.load_detail.distance / 1000),
                        ellipses: true
                    }, (flags === null || flags === void 0 ? void 0 : flags.includes("gmap_route")) && {
                        route: [
                            [
                                data === null || data === void 0 ? void 0 : (ref6 = data.load_detail) === null || ref6 === void 0 ? void 0 : ref6.source_latitude,
                                data === null || data === void 0 ? void 0 : (ref7 = data.load_detail) === null || ref7 === void 0 ? void 0 : ref7.source_longitude
                            ],
                            [
                                data === null || data === void 0 ? void 0 : (ref8 = data.load_detail) === null || ref8 === void 0 ? void 0 : ref8.destination_latitude,
                                data === null || data === void 0 ? void 0 : (ref9 = data.load_detail) === null || ref9 === void 0 ? void 0 : ref9.destination_longitude
                            ]
                        ]
                    })),
                    !!(data === null || data === void 0 ? void 0 : (ref10 = data.load_detail) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.stops) === null || ref11 === void 0 ? void 0 : ref11.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                        justifyContent: "space-between",
                        margin: "9px 0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                size: "auto",
                                filled: true,
                                fillColor: colors/* default.GREY_500 */.Z.GREY_500,
                                faceColor: colors/* default.WHITE */.Z.WHITE,
                                leftNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                                    svgFillColor: colors/* default.WHITE */.Z.WHITE,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_grey/* default */.Z, {})
                                }),
                                children: "MULTI STOP LOAD"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stops_view_LoadStopsPopup, {
                                loadId: data === null || data === void 0 ? void 0 : (ref12 = data.load_detail) === null || ref12 === void 0 ? void 0 : ref12.id,
                                actionText: "Show locations"
                            })
                        ]
                    }),
                    isCsDashboardUser && (flags === null || flags === void 0 ? void 0 : flags.includes("gmap_route")) && destRouteLanLng && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                        justifyContent: "center",
                        margin: "4px 0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: colors/* default.RED */.Z.RED,
                            size: "xs",
                            weight: "semibold",
                            onClick: function() {
                                var ref = (data === null || data === void 0 ? void 0 : data.load_detail) || {}, source_latitude = ref.source_latitude, source_longitude = ref.source_longitude;
                                (0,maps/* openGoogleMapsRoute */.Y)([
                                    [
                                        source_latitude,
                                        source_longitude
                                    ],
                                    destRouteLanLng
                                ]);
                            },
                            underline: true,
                            children: "View Distance from Lorry Current Location"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LineDivider/* default */.Z, {
                        styleType: "solid",
                        linearGradient: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                        gap: 12,
                        flexDirection: "column",
                        margin: "9px 0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketplaceLoadLorryQuickInfo/* default */.Z, {
                                id: id,
                                lorryType: data.load_detail.lorry_type_id,
                                type: "lorry",
                                tyres: data.load_detail.total_tyres,
                                fontWeight: "medium",
                                bodyType: constants/* LORRY_BODY_TYPE_MAP */.ixR[data.load_detail.body_type],
                                lorrySize: data.load_detail.size,
                                lorrySizeText: data.load_detail.size_text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketplaceLoadLorryQuickInfo/* default */.Z, {
                                id: id,
                                type: "load",
                                fontWeight: "medium",
                                material: data.load_detail.material_type,
                                quantity: data.load_detail.quantity,
                                lorryType: data.load_detail.lorry_type_id
                            }),
                            data.load_detail.is_odc && /*#__PURE__*/ (0,jsx_runtime.jsx)(load_card_OdcDetails, {
                                isOdc: data.load_detail.is_odc,
                                height: data.load_detail.height,
                                breadth: data.load_detail.breadth,
                                length: data.load_detail.length
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingTimeBadge/* default */.Z, {
                                id: id,
                                time: data.load_detail.loading_timestamp ? new Date(data.load_detail.loading_timestamp * 1000) : undefined
                            }),
                            isCsDashboardUser && isExpiredLoad && (flags === null || flags === void 0 ? void 0 : flags.includes("expired_time")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* VerticalFlex */.vs, {
                                children: !!data.load_detail.expiration_hour && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    size: "sm",
                                    color: colors/* default.RED */.Z.RED,
                                    weight: "bold",
                                    children: (0,methods/* formatDate */.p6)((0,methods/* toValidDate */.w0)(data.load_detail.expires_at_timestamp * 1000, ""), "Expired at hh:mm a (DD/MM/YY)")
                                })
                            })
                        ]
                    }),
                    showCompanyInfo && (data === null || data === void 0 ? void 0 : (ref13 = data.company_detail) === null || ref13 === void 0 ? void 0 : ref13.id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineDivider/* default */.Z, {
                                styleType: "solid",
                                linearGradient: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    margin: "9px 0px 13px 0"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileInfo/* default */.Z, {
                                        id: id,
                                        companyId: data.company_detail.id,
                                        companyLogo: data.company_detail.logo,
                                        name: data.company_detail.name,
                                        isBankVerified: data.company_detail.is_bank_verified,
                                        isVerified: data.company_detail.is_company_verified,
                                        isAadhaarVerified: data.company_detail.is_aadhaar_verified,
                                        isGstVerified: data.company_detail.is_gst_verified,
                                        isPanVerified: data.company_detail.is_company_verified,
                                        isMember: data.company_detail.is_member,
                                        rating: data.company_detail.ratings,
                                        serviceType: data.company_detail.service_type,
                                        handleClickProfile: handleClickProfile,
                                        phoneNumber: data === null || data === void 0 ? void 0 : (ref14 = data.company_detail) === null || ref14 === void 0 ? void 0 : ref14.phone_number,
                                        agentTagged: !!data.agent_detail,
                                        revealCompanyInfo: isCsDashboardUser,
                                        onReveal: function() {
                                            return handleTracking("reveal_info", {
                                                reveal_target: "load_owner",
                                                load_id: data.load_detail.id,
                                                source_screen: route
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(IfCanAccess/* default */.Z, {
                                        action: "",
                                        allowCsUser: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineDivider/* default */.Z, {
                                                styleType: "solid",
                                                linearGradient: true,
                                                margin: "10px 0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                                                justifyContent: "flex-start",
                                                alignItems: "flex-start",
                                                gap: 12,
                                                flexWrap: "wrap",
                                                children: [
                                                    (flags === null || flags === void 0 ? void 0 : flags.includes("assigned-agents")) && (data === null || data === void 0 ? void 0 : (ref15 = data.assigned_to_details) === null || ref15 === void 0 ? void 0 : ref15.map(function(agent) {
                                                        var label = (agent === null || agent === void 0 ? void 0 : agent.ticket_type) ? ticket_system_helper_constants/* LoadTicketTypeToAgentTypeNameMap */.sz[agent === null || agent === void 0 ? void 0 : agent.ticket_type] : "";
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AgentBadge/* AgentBadgeWithLabel */.y, {
                                                            type: "cs",
                                                            data: agent,
                                                            label: label
                                                        });
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                                                        justifyContent: "flex-start",
                                                        gap: 4,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AgentBadge/* AgentBadgeWithLabel */.y, {
                                                                type: "tso",
                                                                data: data.agent_detail,
                                                                label: "TSO"
                                                            }),
                                                            !!(0,admin/* checkTsoTagged */.p)(data.agent_detail) && /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                                                                action: adminOperation/* ADMIN_OPERATION.tagAgent */.F.tagAgent,
                                                                alsoCheck: !!data.company_detail.id,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (MarketplaceLoadCard_module_default()).callBtn,
                                                                    onClick: _onClickGetContactTso,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                                                                        width: 24,
                                                                        height: 24,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(call_circle/* default */.Z, {})
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((MarketplaceLoadCard_module_default()).footerContent),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(expected_price_and_bid_now_ExpectedPriceAndBidNow, {
                    id: id,
                    onBidNowClick: onBidNowClick,
                    advanceAmount: data.load_detail.advance_payment_percentage,
                    expectedPrice: data.load_detail.amount,
                    paymentType: data.load_detail.payment_type,
                    pricePerTonPerKm: Number(data.load_detail.price_per_tonne_per_km.toFixed(3)),
                    additionalCharge: data === null || data === void 0 ? void 0 : (ref16 = data.load_detail) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.meta_data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.loading_charges_detail) === null || ref18 === void 0 ? void 0 : ref18.charges,
                    isBestPrice: !!((ref19 = data.load_detail.meta_data) === null || ref19 === void 0 ? void 0 : ref19.is_best_price)
                })
            })
        ]
    });
};
/* harmony default export */ var load_card_MarketplaceLoadCard = (MarketplaceLoadCard);
var MarketplaceLoadCardShimmer = function(param) {
    var _mobileResponsive = param.mobileResponsive, mobileResponsive = _mobileResponsive === void 0 ? true : _mobileResponsive;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((MarketplaceLoadCard_module_default()).main, mobileResponsive && (MarketplaceLoadCard_module_default()).mobileResponsive),
        style: {
            display: "flex",
            flexDirection: "column",
            padding: 20,
            gap: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                type: "button",
                width: 50,
                height: 50
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                type: "button"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                type: "button"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                type: "button"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                type: "button",
                height: 50
            })
        ]
    });
};


/***/ }),

/***/ 4546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loading_time_badge_LoadingTimeBadge; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/components/IconWrapper/index.js
var IconWrapper = __webpack_require__(60054);
;// CONCATENATED MODULE: ../core/dist/standard-icons/timer.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgTimer(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.25 7.5a.937.937 0 111.874 0 .937.937 0 01-1.874 0zm-.937-1.875a.937.937 0 100-1.875.937.937 0 000 1.875zM17.552 10a.625.625 0 00-.675.571 6.886 6.886 0 01-13.58.902 6.884 6.884 0 016.13-8.348.627.627 0 00-.104-1.25 8.134 8.134 0 108.802 8.802.625.625 0 00-.573-.677zM10 4.375a5.625 5.625 0 110 11.25 5.625 5.625 0 010-11.25zM9.375 10a.625.625 0 00.625.625h3.75a.625.625 0 100-1.25h-3.125V6.25a.625.625 0 00-1.25 0V10zM12.5 3.75a.937.937 0 100-1.875.937.937 0 000 1.875z",
    fill: "#A4A4A4"
  })));
}

/* harmony default export */ var timer = (SvgTimer);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/methods/time.js
var methods_time = __webpack_require__(72);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
;// CONCATENATED MODULE: ./components/marketplace-new/loading-time-badge/LoadingTimeBadge.tsx








var generateFormattedString = function(time) {
    var today = new Date();
    var day = "";
    if (time.toDateString() === today.toDateString()) {
        day = "Today";
    } else if (time.toDateString() === (0,methods_time/* addDaysOnDate */.zJ)(today, 1).toDateString()) {
        day = "Tomorrow";
    } else {
        day = (0,methods_time/* formatDate */.p6)(time, "DD/MM/YY");
    }
    return "Loading ".concat(day, " at ").concat((0,methods_time/* formatDate */.p6)(time, "h:mm a "));
};
var LoadingTimeBadge = function(param) {
    var id = param.id, renderText = param.renderText, time = param.time;
    var str = time ? generateFormattedString(time) : "Loading time not added.";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
        alignItems: "center",
        gap: 4,
        id: "".concat(id, "--loadingTimestamp"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(timer, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                size: "xs",
                color: colors/* default.ORANGE */.Z.ORANGE,
                children: renderText !== null && renderText !== void 0 ? renderText : str
            })
        ]
    });
};
/* harmony default export */ var loading_time_badge_LoadingTimeBadge = (LoadingTimeBadge);


/***/ }),

/***/ 17238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ marketplace_load_lorry_quick_info_MarketplaceLoadLorryQuickInfo; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var constants = __webpack_require__(94204);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ../core-ui/dist/components/IconWrapper/index.js
var IconWrapper = __webpack_require__(60054);
// EXTERNAL MODULE: ../core/dist/icons/load-grey.svg
var load_grey = __webpack_require__(91809);
// EXTERNAL MODULE: ../core/dist/icons/lorry-icon-grey.svg
var lorry_icon_grey = __webpack_require__(9394);
;// CONCATENATED MODULE: ../core/dist/icons/tyre.svg
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgTyre(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.085 7c0 1.913-.342 3.707-.961 5.05C5.552 13.29 4.794 14 4.042 14c-.75 0-1.51-.71-2.081-1.95C1.34 10.707 1 8.913 1 7c0-1.913.341-3.707.96-5.05C2.534.71 3.292 0 4.043 0l.044.001a.355.355 0 00.07.007h.028c.704.083 1.404.78 1.94 1.942.62 1.343.96 3.137.96 5.05zM5.412 4.402c-.398-1.03-.965-1.246-1.37-1.246-.404 0-.971.216-1.37 1.246-.258.67-.401 1.592-.401 2.598 0 1.006.143 1.928.402 2.598.398 1.03.965 1.246 1.37 1.246.404 0 .971-.216 1.37-1.246.258-.67.401-1.592.401-2.598 0-1.006-.143-1.928-.402-2.598z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M4.043 9.754C3.58 9.754 3.1 8.724 3.1 7s.48-2.754.943-2.754c.463 0 .942 1.03.942 2.754s-.479 2.754-.942 2.754zM8.78 0H6.047c.627.345 1.985 2.96 1.985 6.437 0 5.485-1.51 6.934-1.985 7.514h2.588c.643 0 1.298-.176 1.733-.65.813-.887 1.928-2.793 1.928-6.864 0-3.042-1.116-4.961-2.023-5.899C9.888.141 9.333 0 8.78 0z",
    fill: "#A4A4A4"
  })));
}

/* harmony default export */ var tyre = (SvgTyre);
;// CONCATENATED MODULE: ../core/dist/icons/fuel.svg
var fuel_path;

function fuel_extends() { fuel_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fuel_extends.apply(this, arguments); }



function SvgFuel(props) {
  return /*#__PURE__*/react.createElement("svg", fuel_extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), fuel_path || (fuel_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.913 2.687L11.18.953c-.087 0-.26-.086-.347-.086h-.866c-.26 0-.434.173-.434.433s.174.433.434.433h.433l.867.867h-.434c-.26 0-.433.173-.433.433v1.734c0 .26.173.433.433.433h1.3v3.467c0 .52-.346.866-.866.866s-.867-.346-.867-.866V6.5c0-.26-.173-.433-.433-.433h-1.3V1.3c0-.693-.607-1.3-1.3-1.3h-5.2c-.694 0-1.3.607-1.3 1.3v10.833H0V13h9.533v-.867h-.866v-5.2h.866v1.734c0 .953.78 1.733 1.734 1.733.953 0 1.733-.78 1.733-1.733V3.033c0-.086-.087-.26-.087-.346zM1.733 3.9V1.3c0-.26.174-.433.434-.433h5.2c.26 0 .433.173.433.433v2.6c0 .26-.173.433-.433.433h-5.2c-.26 0-.434-.173-.434-.433zm9.534.433v-.866h.866v.866h-.866z",
    fill: "#A4A4A4"
  })));
}

/* harmony default export */ var fuel = (SvgFuel);
;// CONCATENATED MODULE: ../core/dist/icons/tonne.svg
var tonne_path;

function tonne_extends() { tonne_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tonne_extends.apply(this, arguments); }



function SvgTonne(props) {
  return /*#__PURE__*/react.createElement("svg", tonne_extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), tonne_path || (tonne_path = /*#__PURE__*/react.createElement("path", {
    d: "M1.182 0h10.636C12.47 0 13 .53 13 1.182v10.636C13 12.47 12.47 13 11.818 13H1.182C.53 13 0 12.47 0 11.818V1.182C0 .53.53 0 1.182 0zM2.74 3.748L4.41 5.42a.295.295 0 00.419 0c.586-.586 1.459-.78 2.242-.595l.637-1.4a.295.295 0 11.538.245l-.62 1.364a2.2 2.2 0 01.545.386.295.295 0 00.418 0l1.671-1.67a.295.295 0 000-.419A5.282 5.282 0 006.5 1.773c-1.42 0-2.756.553-3.76 1.558a.295.295 0 000 .417z",
    fill: "#A4A4A4"
  })));
}

/* harmony default export */ var tonne = (SvgTonne);
;// CONCATENATED MODULE: ../core/dist/icons/feet.svg
var feet_path;

function feet_extends() { feet_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return feet_extends.apply(this, arguments); }



function SvgFeet(props) {
  return /*#__PURE__*/react.createElement("svg", feet_extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), feet_path || (feet_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.833 0H1.167A1.17 1.17 0 000 1.167v11.666A1.17 1.17 0 001.167 14h11.666A1.17 1.17 0 0014 12.833V1.167A1.17 1.17 0 0012.833 0zm-.754 7.412l-2.062 2.063-.825-.825 1.066-1.067H3.742L4.809 8.65l-.826.825-2.062-2.063a.583.583 0 010-.824l2.062-2.063.825.825-1.066 1.067h6.517L9.19 5.35l.826-.825 2.062 2.063a.583.583 0 010 .824z",
    fill: "#A4A4A4"
  })));
}

/* harmony default export */ var feet = (SvgFeet);
// EXTERNAL MODULE: ../core-ui/dist/methods/array.js
var array = __webpack_require__(21131);
// EXTERNAL MODULE: ../core/dist/methods/capitalize.js
var capitalize = __webpack_require__(10478);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
;// CONCATENATED MODULE: ./components/marketplace-new/marketplace-load-lorry-quick-info/MarketplaceLoadLorryQuickInfo.tsx








//Assets









var MarketplaceLoadLorryQuickInfo = function(_param) {
    var _id = _param.id, id = _id === void 0 ? "" : _id, type = _param.type, fontWeight = _param.fontWeight, lorryType = _param.lorryType, _size = _param.size, size = _size === void 0 ? "xs" : _size, _mSize = _param.mSize, mSize = _mSize === void 0 ? "xs" : _mSize, props = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "type",
        "fontWeight",
        "lorryType",
        "size",
        "mSize"
    ]);
    var bodyType = props.bodyType, tyres = props.tyres, lorrySize = props.lorrySize, lorrySizeText = props.lorrySizeText, capacity = props.capacity, fuelType = props.fuelType, _showLorryLabel = props.showLorryLabel, showLorryLabel = _showLorryLabel === void 0 ? true : _showLorryLabel;
    var material = props.material, quantity = props.quantity;
    var ref;
    var ref1 = (ref = (0,constants/* getLorryDetailsByType */.X9c)(lorryType)) !== null && ref !== void 0 ? ref : {}, label = ref1.label, unit = ref1.unit, unitSingular = ref1.unitSingular;
    var getLorryDetails = function() {
        return [
            (label || bodyType) && showLorryLabel ? {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(lorry_icon_grey/* default */.Z, {}),
                label: "".concat(label).concat(bodyType ? " . " + bodyType : ""),
                itemId: "lorry-type"
            } : undefined,
            capacity ? {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(tonne, {}),
                label: "".concat(capacity, " ").concat(capacity > 1 ? unit === constants/* LORRY_CAPACITY_UNIT_TYPES.TONNES */.f5d.TONNES ? "Tonnes" : "Kilolitres" : unitSingular),
                itemId: "capacity"
            } : undefined,
            tyres ? {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(tyre, {}),
                label: tyres + " tyres",
                itemId: "tyres"
            } : undefined,
            lorrySize ? {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(feet, {}),
                label: "".concat(lorrySize, " ").concat(lorrySizeText === "ft" ? "feet" : lorrySizeText),
                itemId: "size"
            } : undefined,
            fuelType ? {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fuel, {}),
                label: (0,capitalize/* capitalize */.k)(fuelType === null || fuelType === void 0 ? void 0 : fuelType.toLowerCase()),
                itemId: "fuel-type"
            } : undefined
        ];
    };
    var details = (0,array/* filteredArray */.V3)(type === "load" ? [
        material ? {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(load_grey/* default */.Z, {}),
            label: "".concat(material, " ").concat(quantity ? "(".concat(quantity, " ").concat(quantity > 1 ? unit === constants/* LORRY_CAPACITY_UNIT_TYPES.TONNES */.f5d.TONNES ? "Tonnes" : "Kilolitres" : unitSingular, ")") : ""),
            itemId: "material"
        } : undefined
    ] : (0,_to_consumable_array/* default */.Z)(lorryType != undefined ? getLorryDetails() : []));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
        display: "inline-flex",
        gap: 16,
        alignItems: "center",
        children: details === null || details === void 0 ? void 0 : details.map(function(dt, index) {
            var Icon = dt.icon, label = dt.label, itemId = dt.itemId;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                gap: 5,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                        gap: "5px",
                        height: 16,
                        width: 16,
                        children: Icon
                    }, "icon"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        size: size,
                        mSize: mSize,
                        weight: fontWeight ? fontWeight : "medium",
                        color: type === "load" ? colors/* default.GREY_600 */.Z.GREY_600 : colors/* default.GREY_700 */.Z.GREY_700,
                        id: "".concat(id, "--").concat(itemId),
                        children: label
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var marketplace_load_lorry_quick_info_MarketplaceLoadLorryQuickInfo = (MarketplaceLoadLorryQuickInfo);


/***/ }),

/***/ 32841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _UserProfileInfo_module_scss__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(6244);
/* harmony import */ var _UserProfileInfo_module_scss__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_UserProfileInfo_module_scss__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31013);
/* harmony import */ var _utils_avatar_image_AvatarImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53325);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71960);
/* harmony import */ var _vahak_core_ui_dist_components_TextCTA__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14342);
/* harmony import */ var _user_rating_UserRating__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30616);
/* harmony import */ var _vahak_core_dist_icons_Rupee_Green_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69780);
/* harmony import */ var _vahak_core_dist_icons_verified_tick_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70074);
/* harmony import */ var _vahak_core_dist_icons_VahakMember_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4269);
/* harmony import */ var _vahak_core_dist_icons_Phone_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41628);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94204);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(94897);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4628);
/* harmony import */ var _vahak_core_dist_hooks_useCsDashboard__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68191);
/* harmony import */ var _constants_adminOperation__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(40223);
/* harmony import */ var _admin_IfCanAccess_IfCanAccess__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6632);
/* harmony import */ var _context_call_ClickToCallAppProvider__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50094);
/* harmony import */ var _vahak_core_ui_dist_methods_string__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(75905);
/* harmony import */ var _vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(10182);










//Icons















var UserProfileInfo = function(param) {
    var id = param.id, companyId = param.companyId, companyLogo = param.companyLogo, name = param.name, isBankVerified = param.isBankVerified, isVerified = param.isVerified, rating = param.rating, isAadhaarVerified = param.isAadhaarVerified, isGstVerified = param.isGstVerified, isPanVerified = param.isPanVerified, isMember = param.isMember, serviceType = param.serviceType, handleClickProfile = param.handleClickProfile, phoneNumber = param.phoneNumber, agentTagged = param.agentTagged, _clickToCallMetaInfo = param.clickToCallMetaInfo, clickToCallMetaInfo = _clickToCallMetaInfo === void 0 ? {} : _clickToCallMetaInfo, _revealCompanyInfo = param.revealCompanyInfo, revealCompanyInfo = _revealCompanyInfo === void 0 ? false : _revealCompanyInfo, _requireReveal = param.requireReveal, requireReveal = _requireReveal === void 0 ? true : _requireReveal, revealTarget = param.revealTarget, onReveal = param.onReveal;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_13__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_14__/* .AppContext */ .Il), setHistoryLocation = ref.setHistoryLocation, agentCompanyId = ref.companyId, agentCompanyName = ref.name, route = ref.route;
    var ref1 = (0,_vahak_core_dist_hooks_useCsDashboard__WEBPACK_IMPORTED_MODULE_15__/* .useCsDashboard */ .Z)(), checkPermission = ref1.checkPermission, isTso = ref1.isTso;
    var clickToCallContext = (0,_context_call_ClickToCallAppProvider__WEBPACK_IMPORTED_MODULE_18__/* .useClickToCall */ .k$)();
    var sendGAandMoEngageEvent = (0,_vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_20__/* .useEventTrackerService */ .f)().sendGAandMoEngageEvent;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isRevealed = ref2[0], setIsRevealed = ref2[1];
    var showSensitiveInfo = !requireReveal || isRevealed;
    var _callee_id;
    var resolvedCallParams = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, clickToCallMetaInfo), {
            callee_id: (_callee_id = clickToCallMetaInfo.callee_id) !== null && _callee_id !== void 0 ? _callee_id : companyId
        });
    }, [
        clickToCallMetaInfo,
        companyId
    ]);
    var ctaSlot = clickToCallContext === null || clickToCallContext === void 0 ? void 0 : clickToCallContext.registerCallCta({
        number: "".concat(phoneNumber),
        imgUrl: companyLogo,
        name: name
    }, resolvedCallParams);
    var onClickProfile = function() {
        if (!showSensitiveInfo || isTso) {
            return;
        }
        handleClickProfile === null || handleClickProfile === void 0 ? void 0 : handleClickProfile();
        setHistoryLocation === null || setHistoryLocation === void 0 ? void 0 : setHistoryLocation(router.asPath);
        router.push("".concat(_vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_11__/* .ROUTES.transporterProfile.getUrlWithId */ .Z6p.transporterProfile.getUrlWithId(companyId)));
    };
    var handleReveal = function() {
        setIsRevealed(true);
        if (onReveal) {
            onReveal();
            return;
        }
        sendGAandMoEngageEvent({
            name: "reveal_info",
            data: {
                source_screen: route,
                reveal_target: revealTarget,
                ticket_id: clickToCallMetaInfo.ticket_id,
                load_id: clickToCallMetaInfo.load_id,
                bid_id: clickToCallMetaInfo.bid_id,
                lorry_id: clickToCallMetaInfo.lorry_id,
                agent_company_id: agentCompanyId,
                agent_company_name: agentCompanyName
            }
        });
    };
    var restrictedView = checkPermission(_constants_adminOperation__WEBPACK_IMPORTED_MODULE_16__/* .ADMIN_OPERATION.tagAgentManagerUI */ .F.tagAgentManagerUI);
    var showPhoneNumber = restrictedView ? !!agentTagged : true;
    var PhoneNumberSlot = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_admin_IfCanAccess_IfCanAccess__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        action: _constants_adminOperation__WEBPACK_IMPORTED_MODULE_16__/* .ADMIN_OPERATION.userPhoneNumberVisibilityUI */ .F.userPhoneNumberVisibilityUI,
        alsoCheck: !!phoneNumber && showPhoneNumber,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            alignItems: "center",
            gap: 10,
            children: [
                showSensitiveInfo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_UserProfileInfo_module_scss__WEBPACK_IMPORTED_MODULE_23___default().phoneIcon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_Phone_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            weight: "semibold",
                            size: "xs",
                            color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_12__/* ["default"].GREY_700 */ .Z.GREY_700,
                            children: (0,_vahak_core_ui_dist_methods_string__WEBPACK_IMPORTED_MODULE_19__/* .formattedPhoneNumber */ .p3)(phoneNumber)
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_TextCTA__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    onClick: handleReveal,
                    weight: "medium",
                    underline: true,
                    color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_12__/* ["default"].RED */ .Z.RED,
                    children: "Reveal Info"
                }),
                ctaSlot
            ]
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        className: (_UserProfileInfo_module_scss__WEBPACK_IMPORTED_MODULE_23___default().main),
        alignItems: "center",
        gap: rating ? 16 : 6,
        children: [
            revealCompanyInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_UserProfileInfo_module_scss__WEBPACK_IMPORTED_MODULE_23___default().logoWrapper),
                id: "".concat(id, "--companyLogo"),
                onClick: showSensitiveInfo ? onClickProfile : undefined,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_avatar_image_AvatarImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: (_UserProfileInfo_module_scss__WEBPACK_IMPORTED_MODULE_23___default().logo),
                        imageUrl: companyLogo,
                        firstName: name,
                        size: "s"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_UserProfileInfo_module_scss__WEBPACK_IMPORTED_MODULE_23___default().rating),
                        children: Boolean(rating) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_user_rating_UserRating__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            rating: rating
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_UserProfileInfo_module_scss__WEBPACK_IMPORTED_MODULE_23___default().company),
                children: [
                    revealCompanyInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        id: "".concat(id, "--companyName"),
                        weight: "semibold",
                        size: "sm",
                        color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_12__/* ["default"].GREY_900 */ .Z.GREY_900,
                        "data-one-line-text": true,
                        title: name,
                        children: name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_UserProfileInfo_module_scss__WEBPACK_IMPORTED_MODULE_23___default().companyDesc),
                        children: [
                            !!isBankVerified && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_Rupee_Green_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                            !!(isVerified || isAadhaarVerified || isGstVerified || isPanVerified) && !isMember && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_verified_tick_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                            !!isMember && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_VahakMember_svg__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                weight: "semibold",
                                size: "xs",
                                color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_12__/* ["default"].GREY_700 */ .Z.GREY_700,
                                id: "".concat(id, "--serviceType"),
                                "data-service-type": true,
                                "data-one-line-text": true,
                                title: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_11__/* .CompanyServiceTypeMap */ .s6W[serviceType],
                                children: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_11__/* .CompanyServiceTypeMap */ .s6W[serviceType]
                            })
                        ]
                    }),
                    PhoneNumberSlot
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UserProfileInfo);


/***/ }),

/***/ 30616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _UserRating_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91359);
/* harmony import */ var _UserRating_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_UserRating_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _vahak_core_dist_standard_icons_rating_star_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11831);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71960);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94897);



//Style

//Icon

//Components


var UserRating = function(param) {
    var rating = param.rating, flat = param.flat;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_UserRating_module_scss__WEBPACK_IMPORTED_MODULE_6___default().main), flat && (_UserRating_module_scss__WEBPACK_IMPORTED_MODULE_6___default().flat)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_standard_icons_rating_star_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                size: "xs",
                mSize: "xs",
                weight: "semibold",
                color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_5__/* ["default"].GREY_700 */ .Z.GREY_700,
                children: rating.toFixed(1) || 0
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UserRating);


/***/ }),

/***/ 4194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71960);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94897);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31013);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);







var LabelValue = function(param) {
    var label = param.label, value = param.value, maxWidth = param.maxWidth, labelProps = param.labelProps, valueProps = param.valueProps, _gap = param.gap, gap = _gap === void 0 ? 12 : _gap, direction = param.direction;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        flexDirection: direction || "column",
        style: {
            maxWidth: maxWidth
        },
        gap: gap,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].GREY_700 */ .Z.GREY_700
            }, labelProps), {
                children: label
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].GREY_1000 */ .Z.GREY_1000,
                weight: "medium"
            }, valueProps), {
                children: value
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LabelValue);


/***/ }),

/***/ 85820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ C2C_REFERENCE_TYPE; }
/* harmony export */ });
/**
 * Click-to-call (C2C) reference types for call-log mapping.
 * Each screen / card must pass its own unique type — do not reuse another surface’s value.
 *
 * Mapping doc: https://vahak.atlassian.net/wiki/spaces/PR/pages/789938177/Call+logs+mapping
 * Numeric ids are offset by +1000 from the original wiki sequence.
 *
 * When adding a new click-to-call CTA:
 * 1. Add a new enum member (never reuse an existing id for a different screen)
 * 2. Use that member only from that screen/card
 *
 * Ticket system: always pass ticket_id as reference_id with TICKET_SYSTEM as reference_type.
 */ var C2C_REFERENCE_TYPE;
(function(C2C_REFERENCE_TYPE) {
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE[// —— Core entities ——
    "LOAD"] = 1001] = "LOAD";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["LORRY"] = 1002] = "LORRY";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["NETWORK"] = 1003] = "NETWORK";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE[// —— Transactions ——
    "TRANSACTION_LOAD_BID"] = 1005] = "TRANSACTION_LOAD_BID";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TRANSACTION_LORRY_BID"] = 1006] = "TRANSACTION_LORRY_BID";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE[// —— My bids (consumer marketplace lists) ——
    "LOAD_MY_BID_RECEIVED"] = 1007] = "LOAD_MY_BID_RECEIVED";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["LOAD_MY_BID_SENT"] = 1008] = "LOAD_MY_BID_SENT";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["LORRY_MY_BID_RECEIVED"] = 1009] = "LORRY_MY_BID_RECEIVED";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["LORRY_MY_BID_SENT"] = 1010] = "LORRY_MY_BID_SENT";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE[// —— Profile / directory ——
    "PROFILE"] = 1011] = "PROFILE";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TRANSPORT_DIRECTORY"] = 1012] = "TRANSPORT_DIRECTORY";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["PROFILE_BIDDER_KAM"] = 1013] = "PROFILE_BIDDER_KAM";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["PROFILE_USER_BASIC_INFO"] = 1014] = "PROFILE_USER_BASIC_INFO";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TRANSPORT_DIRECTORY_CARD"] = 1015] = "TRANSPORT_DIRECTORY_CARD";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE[// —— TSO / tagged user ——
    "AGENT_LOAD"] = 1020] = "AGENT_LOAD";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TAGGED_USER_LOAD_BID"] = 1021] = "TAGGED_USER_LOAD_BID";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TAGGED_USER_LOAD_ENQUIRY_CARD"] = 1022] = "TAGGED_USER_LOAD_ENQUIRY_CARD";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TAGGED_USER_LOAD_LIVE_LORRY"] = 1023] = "TAGGED_USER_LOAD_LIVE_LORRY";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TAGGED_USER_LORRY_LIVE_LOAD"] = 1024] = "TAGGED_USER_LORRY_LIVE_LOAD";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["ASSURED_LOAD_TAGGED_LIVE_LORRY"] = 1025] = "ASSURED_LOAD_TAGGED_LIVE_LORRY";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TAGGED_USER_DETAIL_SCREEN"] = 1026] = "TAGGED_USER_DETAIL_SCREEN";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TSO_LOAD_POSTED_SCREEN"] = 1027] = "TSO_LOAD_POSTED_SCREEN";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TSO_LORRY_POSTED_SCREEN"] = 1028] = "TSO_LORRY_POSTED_SCREEN";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TAGGED_USER_LOAD_PAST_TRANSACTOR"] = 1029] = "TAGGED_USER_LOAD_PAST_TRANSACTOR";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TAGGED_USER_LOAD_MY_BID"] = 1030] = "TAGGED_USER_LOAD_MY_BID";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TAGGED_USER_LOAD_EXPIRED_LORRY"] = 1031] = "TAGGED_USER_LOAD_EXPIRED_LORRY";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TAGGED_USER_LOAD_LIVES"] = 1032] = "TAGGED_USER_LOAD_LIVES";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["AGENT_LORRY"] = 1033] = "AGENT_LORRY";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["TAGGED_USER_LORRY_MY_BID"] = 1035] = "TAGGED_USER_LORRY_MY_BID";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE[// —— Consumer marketplace ——
    "LOAD_MARKETPLACE"] = 1036] = "LOAD_MARKETPLACE";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE["LORRY_MARKETPLACE"] = 1037] = "LORRY_MARKETPLACE";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE[// —— Load details / in-transit ——
    "IN_TRANSIT_STATUS_TRACKING"] = 1038] = "IN_TRANSIT_STATUS_TRACKING";
    C2C_REFERENCE_TYPE[C2C_REFERENCE_TYPE[// —— Admin ticket system (common for all ticket screens/cards) ——
    "TICKET_SYSTEM"] = 1040] = "TICKET_SYSTEM";
})(C2C_REFERENCE_TYPE || (C2C_REFERENCE_TYPE = {}));


/***/ }),

/***/ 83463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ CONTACT_US_CALL_BACK_REQUEST; },
/* harmony export */   "aP": function() { return /* binding */ CONTACT_DAILY_LIMIT; },
/* harmony export */   "eO": function() { return /* binding */ CALL_BACK_REQUEST; },
/* harmony export */   "xg": function() { return /* binding */ SUPPORT_MENU; },
/* harmony export */   "ym": function() { return /* binding */ LOGIN; }
/* harmony export */ });
/* unused harmony exports SERVICE_TYPE_MODAL, CONFIRM_CANCEL_MODAL, LOAD_BID, LORRY_BID, MOBILE_FILTERS_MARKETPLACE, SRC_SEARCH_VISIBLE, DEST_SEARCH_VISIBLE, HOMEPAGE_SRC_SEARCH_VISIBLE, HOMEPAGE_DEST_SEARCH_VISIBLE, LOAD_POSTING_FORM, LORRY_POSTING_FORM, SHARE_MODAL */
var SERVICE_TYPE_MODAL = "ServiceTypeModal";
var CONFIRM_CANCEL_MODAL = "ConfirmCancelModal";
var LOAD_BID = "loadbid";
var LORRY_BID = "lorrybid";
var SUPPORT_MENU = "SupportMenu";
var CALL_BACK_REQUEST = "CallBackReq";
var CONTACT_US_CALL_BACK_REQUEST = "ContactUsCallBack";
var MOBILE_FILTERS_MARKETPLACE = "Filters";
var SRC_SEARCH_VISIBLE = "SourceSearchVisible";
var DEST_SEARCH_VISIBLE = "DestinationSearchVisible";
var HOMEPAGE_SRC_SEARCH_VISIBLE = "SourceSearch";
var HOMEPAGE_DEST_SEARCH_VISIBLE = "DestinationSearch";
var CONTACT_DAILY_LIMIT = "contact-daily-limit";
var LOGIN = "Login";
var LOAD_POSTING_FORM = "LoadPostingForm";
var LORRY_POSTING_FORM = "LorryPostingForm";
var SHARE_MODAL = "ShareModal";


/***/ }),

/***/ 51473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ useGetContactDetails; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/_services/user-analytics.service.js
var user_analytics_service = __webpack_require__(8880);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./constants/modal-strings.ts
var modal_strings = __webpack_require__(83463);
// EXTERNAL MODULE: ./hooks/useToggleModal.tsx
var useToggleModal = __webpack_require__(91467);
// EXTERNAL MODULE: ../core/dist/_services/callBack.service.js
var callBack_service = __webpack_require__(22672);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ../core/dist/methods/copyToClipboard.js
var copyToClipboard = __webpack_require__(54534);
// EXTERNAL MODULE: ../core/dist/icons/copy.svg
var copy = __webpack_require__(55525);
// EXTERNAL MODULE: ../core-ui/dist/components/IconWrapper/index.js
var IconWrapper = __webpack_require__(60054);
// EXTERNAL MODULE: ../core/dist/hooks/useCsDashboard.js
var useCsDashboard = __webpack_require__(68191);
;// CONCATENATED MODULE: ./hooks/useDirectCall.ts




var useDirectCall = function() {
    var fromFlutterApp = (0,react.useContext)(app_context/* AppContext */.Il).fromFlutterApp;
    var isTsoV2 = (0,useCsDashboard/* useCsDashboard */.Z)().isTsoV2;
    var directCall = function(phoneNumber) {
        if (!phoneNumber) {
            console.warn("Phone number is empty.");
            return;
        }
        // Sanitize input (basic)
        var cleaned = phoneNumber.replace(/[^+\d]/g, "");
        // Flutter WebView has no usable dialer — copy instead of tel:
        if (isTsoV2 && fromFlutterApp) {
            (0,copyToClipboard/* copyToClipboard */.v)(cleaned, "Phone number copied!");
            return;
        }
        // Open the tel link
        window.location.href = "tel:".concat(cleaned);
    };
    return {
        directCall: directCall
    };
};
/* harmony default export */ var hooks_useDirectCall = (useDirectCall);

;// CONCATENATED MODULE: ./hooks/useGetContactDetails.tsx






// Translation











function useGetContactDetails(transporterId) {
    var t = (0,esm/* useTranslation */.$G)([
        "transporters",
        "common"
    ]).t;
    var ref = (0,useToggleModal/* useToggleModal */.x)(modal_strings/* LOGIN */.ym), openLoginModal = ref.openModal, closeLoginModal = ref.closeModal;
    var ref1 = (0,useToggleModal/* useToggleModal */.x)(modal_strings/* CONTACT_DAILY_LIMIT */.aP), openLimitReachedModal = ref1.openModal, onToggleLimitReachedModal = ref1.handleToggle;
    var ref2 = (0,react.useContext)(app_context/* AppContext */.Il), numOfContactRqsts = ref2.numOfContactRqsts, updateNumOfContactRqsts = ref2.updateNumOfContactRqsts, transporterContactsRqstd = ref2.transporterContactsRqstd, isPhoneVerified = ref2.isPhoneVerified;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var directCall = hooks_useDirectCall().directCall;
    // const openLoginModal = () => {
    //     history.push({
    //         state: {
    //             ...history.location.state,
    //             isLoginModalVisible: true
    //         },
    //         search: history.location.search
    //     });
    // };
    var onToggleGetContactDetailsModal = function() {
        if (router_default().asPath.includes(modal_strings/* LOGIN */.ym)) {
            return;
        } else {
            openLoginModal();
        }
    };
    var sendContactDetails = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var callerId, calleeId, referenceId, referenceType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        callerId = param.callerId, calleeId = param.calleeId, referenceId = param.referenceId, referenceType = param.referenceType;
                        _ctx.next = 3;
                        return (0,callBack_service/* newCustomer2CustomerCallbackRequest */.F)({
                            callerId: callerId,
                            calleeId: calleeId,
                            referenceId: referenceId,
                            referenceType: referenceType
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendContactDetails(_) {
            return _ref.apply(this, arguments);
        };
    }();
    // const onClickGetContact = (companyPhoneNumber?: string) => {
    //     if (transporterContactsRqstd?.includes(transporterId)) {
    //         toast.info(t("toast.already_sent"));
    //     } else {
    //         if (numOfContactRqsts && numOfContactRqsts >= 10) {
    //             openLimitReachedModal();
    //         } else {
    //             if (numOfContactRqsts && numOfContactRqsts < 5)
    //                 ga4sendEvent("Directory_Total_contactdetails_web", { value: 1 });
    //             else ga4sendEvent("Directory_Total_contactdetails_web", { value: 0 });
    //             if (!isPhoneVerified) {
    //                 openLoginModal();
    //                 document.addEventListener(CUSTOM_EVENTS.LOGGEDIN, () => {
    //                     copyPhoneNum(companyPhoneNumber);
    //                 });
    //             } else {
    //                 copyPhoneNum(companyPhoneNumber);
    //             }
    //         }
    //     }
    // };
    var connectC2C = function(param) {
        var callerId = param.callerId, calleeId = param.calleeId, referenceId = param.referenceId, referenceType = param.referenceType;
        if (transporterContactsRqstd === null || transporterContactsRqstd === void 0 ? void 0 : transporterContactsRqstd.includes(transporterId)) {
            toast/* toast.info */.A.info(t("toast.already_sent"));
        } else {
            if (numOfContactRqsts && numOfContactRqsts >= 10) {
                openLimitReachedModal();
            } else {
                if (numOfContactRqsts && numOfContactRqsts < 5) (0,user_analytics_service/* ga4sendEvent */.zs)("Directory_Total_contactdetails_web", {
                    value: 1
                });
                else (0,user_analytics_service/* ga4sendEvent */.zs)("Directory_Total_contactdetails_web", {
                    value: 0
                });
                if (!isPhoneVerified) {
                    openLoginModal();
                } else {
                    sendContactDetails({
                        callerId: callerId,
                        calleeId: calleeId,
                        referenceId: referenceId,
                        referenceType: referenceType
                    }).then(function(vNum) {
                        if (vNum) {
                            if (isMobileScreen) directCall(vNum);
                            else {
                                toast/* toast.success */.A.success(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    onClick: function() {
                                        return (0,copyToClipboard/* copyToClipboard */.v)(vNum);
                                    },
                                    children: [
                                        "Please call on \xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: vNum
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                                            svgFillColor: "#fff",
                                            height: 18,
                                            width: 18,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(copy/* default */.Z, {})
                                        })
                                    ]
                                }), {
                                    autoClose: 20000
                                });
                            }
                        }
                    });
                }
            }
        }
    };
    return {
        onToggleGetContactDetailsModal: onToggleGetContactDetailsModal,
        onToggleLimitReachedModal: onToggleLimitReachedModal,
        // onClickGetContact,
        connectC2C: connectC2C
    };
}


/***/ }),

/***/ 91467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useToggleModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _methods_getPathName__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48929);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);



function useToggleModal(modalName) {
    var handleToggle = function() {
        if (!next_router__WEBPACK_IMPORTED_MODULE_1___default().asPath.includes(modalName)) {
            openModal(modalName);
        } else {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
                pathname: (0,_methods_getPathName__WEBPACK_IMPORTED_MODULE_0__/* .getPathName */ .y)(),
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_1___default().query)),
                hash: undefined
            }, undefined, {
                shallow: true
            });
        }
    };
    var openModal = function(currentModalName) {
        modalName = currentModalName || modalName;
        var currentHash = next_router__WEBPACK_IMPORTED_MODULE_1___default().asPath.split("#").slice(1).join("#");
        if (currentHash && !currentHash.includes(modalName)) {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
                pathname: (0,_methods_getPathName__WEBPACK_IMPORTED_MODULE_0__/* .getPathName */ .y)(),
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_1___default().query)),
                hash: "".concat(currentHash, "#").concat(modalName)
            }, undefined, {
                shallow: true
            });
        } else {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
                pathname: (0,_methods_getPathName__WEBPACK_IMPORTED_MODULE_0__/* .getPathName */ .y)(),
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_1___default().query)),
                hash: modalName
            }, undefined, {
                shallow: true
            });
        }
    };
    var closeModal = function(currentModalName) {
        modalName = currentModalName || modalName;
        var numOfModalsOpen = next_router__WEBPACK_IMPORTED_MODULE_1___default().asPath.split("#").length - 1;
        var currentHash = next_router__WEBPACK_IMPORTED_MODULE_1___default().asPath.split("#").slice(1).join("#");
        if (numOfModalsOpen > 1) {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
                pathname: (0,_methods_getPathName__WEBPACK_IMPORTED_MODULE_0__/* .getPathName */ .y)(),
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_1___default().query)),
                hash: currentHash.replace("#".concat(modalName), "")
            }, undefined, {
                shallow: true
            });
        } else {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
                pathname: (0,_methods_getPathName__WEBPACK_IMPORTED_MODULE_0__/* .getPathName */ .y)(),
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_1___default().query)),
                hash: undefined
            }, undefined, {
                shallow: true
            });
        }
    };
    return {
        handleToggle: handleToggle,
        openModal: openModal,
        closeModal: closeModal
    };
}


/***/ }),

/***/ 90756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ checkTsoTagged; }
/* harmony export */ });
var checkTsoTagged = function() {
    var tso = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    var user_id = (ref = tso === null || tso === void 0 ? void 0 : tso.user_id) !== null && ref !== void 0 ? ref : 1;
    return user_id > 1;
};


/***/ }),

/***/ 12461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useGetLatAndLongBasedOnPlaceIdV1; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36153);
/* harmony import */ var _queryNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9433);




var useGetLatAndLongBasedOnPlaceIdV1 = function() {
    var GET = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().GET;
    var getLatAndLongBasedOnPlaceId = function(param) {
        var place_id = param.place_id;
        var queryParamObj = {
            place_id: place_id
        };
        return GET(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LAT_LONG_BY_PLACE_ID */ .Z.LAT_LONG_BY_PLACE_ID, queryParamObj);
    };
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_1__/* .useVahakMutationQuery */ .M8)([
        _queryNames__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getLatAndLongBasedOnPlaceId */ .Z.getLatAndLongBasedOnPlaceId
    ], getLatAndLongBasedOnPlaceId);
};


/***/ }),

/***/ 21264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useGetCashbackLimit; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49352);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36153);
/* harmony import */ var _vahak_core_dist_methods_generateQueryString__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99073);







var useGetCashbackLimit = function(params, options) {
    var GET = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().GET;
    var method = function() {
        var urlString = (0,_vahak_core_dist_methods_generateQueryString__WEBPACK_IMPORTED_MODULE_4__/* .generateQueryString */ .T)({
            transaction_type: params.type
        });
        return GET("".concat(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__/* ["default"].GET_CASHBACK_USAGE_LIMIT */ .Z.GET_CASHBACK_USAGE_LIMIT).concat(urlString));
    };
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_2__/* .useVahakQuery */ .uE)([
        _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_0__/* .QueryNames.payment.cashBackLimit */ ._.payment.cashBackLimit,
        params
    ], method, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, options), {
        select: function(data) {
            return data;
        }
    }));
};


/***/ }),

/***/ 82933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useUpdateRemarks; },
/* harmony export */   "l": function() { return /* binding */ UpdateRemarksReferenceType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49352);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36153);






var UpdateRemarksReferenceType;
(function(UpdateRemarksReferenceType) {
    UpdateRemarksReferenceType[UpdateRemarksReferenceType["LOAD"] = 1] = "LOAD";
    UpdateRemarksReferenceType[UpdateRemarksReferenceType["LORRY"] = 2] = "LORRY";
    UpdateRemarksReferenceType[UpdateRemarksReferenceType["LOAD_BID"] = 5] = "LOAD_BID";
    UpdateRemarksReferenceType[UpdateRemarksReferenceType["LORRY_BID"] = 6] = "LORRY_BID";
    UpdateRemarksReferenceType[UpdateRemarksReferenceType["TICKETS"] = 7] = "TICKETS";
})(UpdateRemarksReferenceType || (UpdateRemarksReferenceType = {}));
var useUpdateRemarks = function(option) {
    var updateRemarks = function updateRemarks(data) {
        var ref, ref1;
        var payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), {
            other: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.other) === null || ref === void 0 ? void 0 : ref.replace(/\s+/g, " ")) === null || ref1 === void 0 ? void 0 : ref1.trim()
        });
        return POST(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__/* ["default"].UPDATE_REMARKS */ .Z.UPDATE_REMARKS, payload);
    };
    var POST = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().POST;
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_2__/* .useVahakMutationQuery */ .M8)([
        _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_0__/* .QueryNames.updateRemarks */ ._.updateRemarks
    ], updateRemarks, option);
};


/***/ }),

/***/ 43916:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"LoadStopsList_main__7lMCi","locations":"LoadStopsList_locations__TOsjy","locationDividerWrapper":"LoadStopsList_locationDividerWrapper__G1eqp","location":"LoadStopsList_location__uliGZ","locationIcon":"LoadStopsList_locationIcon__z9AxM","dot":"LoadStopsList_dot__f8_ms","divider":"LoadStopsList_divider__ylXhH","distance":"LoadStopsList_distance__Jw8TA"};

/***/ }),

/***/ 35145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"ExpectedPriceAndBidNow_main__PzTXb","container":"ExpectedPriceAndBidNow_container__3f1qv","bidNowBtn":"ExpectedPriceAndBidNow_bidNowBtn__PIMDg"};

/***/ }),

/***/ 50307:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"MarketplaceLoadCard_main__q331F","headerContent":"MarketplaceLoadCard_headerContent__91CnF","actionBtnWrapper":"MarketplaceLoadCard_actionBtnWrapper__BSWbI","adminOptionDropdown":"MarketplaceLoadCard_adminOptionDropdown__DsLhq","shareBtn":"MarketplaceLoadCard_shareBtn__Ta7q_","bodyContent":"MarketplaceLoadCard_bodyContent__tDyCS","footerContent":"MarketplaceLoadCard_footerContent__OlSJ8","singleChild":"MarketplaceLoadCard_singleChild__2j26s","mobileResponsive":"MarketplaceLoadCard_mobileResponsive__Ei_k5"};

/***/ }),

/***/ 6244:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"UserProfileInfo_main__0lqPj","logoWrapper":"UserProfileInfo_logoWrapper__Wyecp","logo":"UserProfileInfo_logo__ArUwN","rating":"UserProfileInfo_rating__cKI16","company":"UserProfileInfo_company__2HZ7Y","companyDesc":"UserProfileInfo_companyDesc__omwVJ"};

/***/ }),

/***/ 91359:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"UserRating_main__n2nIT","flat":"UserRating_flat__VqjDc"};

/***/ })

}]);